import React, { useEffect, useState } from "react";
import { Link, redirect, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment, { min } from "moment";
import { Spin } from "antd";
import {
  customConfirmDialog,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import { SVGICON } from "../../../constant/theme";
import Cropper from "react-cropper";
import {
  dataUrlToFile,
  dataUrlToFileUsingFetch,
} from "../../../CustomControls/Utils";
import "cropperjs/dist/cropper.css";
import { useRef } from "react";
import Webcam from "react-webcam";
import {
  POST_DDLGetInwardListForInwardClubing,
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetCustomerContactPersonDDL,
  POST_GetCustomerContactPersonDDLByCustomerProject,
  POST_GetCustomerDDLList,
  POST_GetCustomerDDLListAJAX,
  POST_GetCustomerProjectAddressDDLList,
  // POST_GetCustomerProjectContactPersonDDLList,
  POST_GetCustomerProjectList,
  // POST_GetDepartmentDropDownList,
  POST_GetEmployeeDDLList,
  POST_GetInvoiceInwardNoListByCustomerID,
  POST_GetMaterialInwardDetailByID,
  POST_GetMaterialInwardProjectWorkDetailDDLList,
  // POST_GetMaterialTypeDDLListByDepartment_ProductGroup,
  POST_GetVoucherSeriesDDLList,
  POST_MaterialInwardHeaderDetailChange,
  POST_MaterialInwardInsert,
  POST_MaterialInwardUpdate,
  POST_ProductGroupDropDownList,
  POST_ValidateCustomerCredit,
  // POST_ProductGroupDropDownListByDepartmentID,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
// import swal from "sweetalert";

const AddMaterialInward = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam, CopyInwardIdParam, editHeaderInwardIdParam } =
    useParams();

  const [inwardNoOptions, setInwardNoOptions] = useState([]);
  // const [customerOptions, setCustomerOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [stampWriteUpOptions, setStampWriteUpOptions] = useState([]);
  // const [departmentOptions, setDepartmentOptions] = useState([]);
  const [modeByOptions, setModeByOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [sampleReceivedViaOptions, setSampleReceivedViaOptions] = useState([]);
  const [referredByOptions, setReferredByOptions] = useState([]);
  const [tpiCustomerOptions, setTPICustomerOptions] = useState([]);
  const [tpiContactPersonOptions, setTPIContactPersonOptions] = useState([]);
  const [dispatchMaterialModeOptions, setDispatchMaterialModeOptions] =
    useState([]);
  const [tcNoOptions, setTCNoOptions] = useState([]);
  const [productGroupOptions, setProductGroupOptions] = useState([]);

  const yesNoOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const [stampImage, setStampImage] = useState(null);
  const [stampImageFile, setStampImageFile] = useState(null);

  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);
  const [showAddTPIDetailModal, setShowAddTPIDetailModal] = useState(false);
  const [showTPIDetailModal, setShowTPIDetailModal] = useState(false);
  const [showMaterialInfoImagesModal, setShowMaterialInfoImagesModal] =
    useState(false);
  const [
    showMaterialInfoRepeatRowQtyModal,
    setShowMaterialInfoRepeatRowQtyModal,
  ] = useState(false);
  const [showWorkDetailModal, setShowWorkDetailModal] = useState(false);

  const webcamRef = useRef(null);

  const videoConstraints = {
    width: 600,
    height: 600,
    facingMode: "environment",
  };

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const getInwardNoDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 1, // 1 = Inward
      TranDate: InwardDate
        ? moment(InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setInwardNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item.VoucherSeries,
              value: item.VoucherSeriesIDEncrypt,
              IsTCNoBasedOnInwardNo: item.IsTCNoBasedOnInwardNo,
            }))
          );
          if (InwardNo) {
            if (
              response?.VoucherSeriesList?.filter(
                (x) => x.VoucherSeriesIDEncrypt == InwardNo
              )?.length == 0
            ) {
              formik.setFieldValue("InwardNo", "");
            }
          } else {
            /*select the value when there is only one option while insert only*/
            if (response?.VoucherSeriesList?.length == 1 && !PrimaryIdParam) {
              formik.setFieldValue(
                "InwardNo",
                response?.VoucherSeriesList[0].VoucherSeriesIDEncrypt
              );
              formik.setFieldValue(
                "IsTCNoBasedOnInwardNo",
                response?.VoucherSeriesList[0].IsTCNoBasedOnInwardNo
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTCNoDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 5, // 5 = TCNo
      TranDate: InwardDate
        ? moment(InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTCNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item?.VoucherSeries,
              value: item?.VoucherSeriesIDEncrypt,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const getCustomerDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetCustomerDDLListAJAX, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     SearchValue: "",
  //     TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setCustomerOptions(
  //           response?.CustomerDDLList?.map((item) => ({
  //             label: item.CustomerName,
  //             value: item.CustomerIDEncrypted,
  //           }))
  //         );

  //         /*select the value when there is only one option while insert only*/
  //         if (response?.CustomerDDLList?.length == 1 && !PrimaryIdParam) {
  //           formik.setFieldValue(
  //             "CustomerIDEncrypted",
  //             response?.CustomerDDLList[0].CustomerIDEncrypted
  //           );
  //         }
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const getTPICustomerDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: 1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPICustomerOptions(
            response?.CustomerDDLList?.filter((x) => x.IsTPI == true)?.map(
              (item) => ({
                label: item.CustomerName,
                value: item.CustomerIDEncrypted,
              })
            )
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectDDL = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: customerID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            }))
          );
          if (
            response?.CustomerProjectDDLList?.length >= 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted
            ).length == 0
          ) {
            formik.setFieldValue("CustomerProjectIDEncrypted", "");
            formik.setFieldValue("CustomerProjectName", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.CustomerProjectDDLList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "CustomerProjectIDEncrypted",
                response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt
              );
              formik.setFieldValue(
                "CustomerProjectName",
                response?.CustomerProjectDDLList[0].ProjectName
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const getStampWriteUpDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetCustomerProjectContactPersonDDLList, {
  //     CustomerIDEncrypted: CustomerIDEncrypted,
  //     CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setStampWriteUpOptions(
  //           response?.ContactPersonDDLList?.filter(
  //             (x) => x.StempWriteup != ""
  //           )?.map((item) => ({
  //             label: item.StempWriteup,
  //             value: item.CustomerContactPersonIDEncrypted,
  //           }))
  //         );
  //         if (
  //           response?.ContactPersonDDLList?.filter((x) => x.StempWriteup != "")
  //             ?.length > 0 &&
  //           StampWriteUpIDEncrypted &&
  //           response?.ContactPersonDDLList?.filter(
  //             (x) => x.StempWriteup != ""
  //           )?.filter(
  //             (x) =>
  //               x.CustomerContactPersonIDEncrypted == StampWriteUpIDEncrypted
  //           ).length == 0
  //         ) {
  //           formik.setFieldValue("StampWriteUpIDEncrypted", "");
  //         } else {
  //           /*select the value when there is only one option while insert only*/
  //           if (
  //             response?.ContactPersonDDLList?.length == 1 &&
  //             !PrimaryIdParam
  //           ) {
  //             formik.setFieldValue(
  //               "StampWriteUpIDEncrypted",
  //               response?.ContactPersonDDLList[0]
  //                 .CustomerContactPersonIDEncrypted
  //             );
  //           }
  //         }

  //         response?.ContactPersonDDLList?.map((item) => ({
  //           label: item.ContactPerson,
  //           value: item.CustomerContactPersonIDEncrypted,
  //         }));
  //         setReferredByOptions(
  //           response?.ContactPersonDDLList?.map((item) => ({
  //             label: item.ContactPerson,
  //             value: item.CustomerContactPersonIDEncrypted,
  //           }))
  //         );
  //         if (
  //           response?.ContactPersonDDLList?.length > 0 &&
  //           ReferenceByIDEncrypted &&
  //           response?.ContactPersonDDLList?.filter(
  //             (x) =>
  //               x.CustomerContactPersonIDEncrypted == ReferenceByIDEncrypted
  //           ).length == 0
  //         ) {
  //           formik.setFieldValue("ReferenceByIDEncrypted", "");
  //         } else {
  //           /*select the value when there is only one option while insert only*/
  //           if (
  //             response?.ContactPersonDDLList?.length == 1 &&
  //             !PrimaryIdParam
  //           ) {
  //             formik.setFieldValue(
  //               "ReferenceByIDEncrypted",
  //               response?.ContactPersonDDLList[0]
  //                 .CustomerContactPersonIDEncrypted
  //             );
  //           }
  //         }
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const getStampWriteUpDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: CustomerIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setStampWriteUpOptions(
            response?.ListOfContactPersons?.filter(
              (x) => x.StempWriteup != ""
            )?.map((item) => ({
              label: item.StempWriteup,
              value: item.CustomerContactPersonIDEncrypted,
            }))
          );
          if (
            response?.ListOfContactPersons?.filter((x) => x.StempWriteup != "")
              ?.length > 0 &&
            StampWriteUpIDEncrypted &&
            response?.ListOfContactPersons?.filter(
              (x) => x.StempWriteup != ""
            )?.filter(
              (x) =>
                x.CustomerContactPersonIDEncrypted == StampWriteUpIDEncrypted
            ).length == 0
          ) {
            formik.setFieldValue("StampWriteUpIDEncrypted", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.ListOfContactPersons?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "StampWriteUpIDEncrypted",
                response?.ListOfContactPersons[0]
                  .CustomerContactPersonIDEncrypted
              );
            }
          }

          response?.ListOfContactPersons?.map((item) => ({
            label: item.ContactPerson,
            value: item.CustomerContactPersonIDEncrypted,
          }));

          // setReferredByOptions(
          //   response?.ListOfContactPersons?.map((item) => ({
          //     label: item.ContactPerson,
          //     value: item.CustomerContactPersonIDEncrypted,
          //   }))
          // );
          // if (
          //   response?.ListOfContactPersons?.length > 0 &&
          //   ReferenceByIDEncrypted &&
          //   response?.ListOfContactPersons?.filter(
          //     (x) =>
          //       x.CustomerContactPersonIDEncrypted == ReferenceByIDEncrypted
          //   ).length == 0
          // ) {
          //   formik.setFieldValue("ReferenceByIDEncrypted", "");
          // } else {
          //   /*select the value when there is only one option while insert only*/
          //   if (
          //     response?.ListOfContactPersons?.length == 1 &&
          //     !PrimaryIdParam
          //   ) {
          //     formik.setFieldValue(
          //       "ReferenceByIDEncrypted",
          //       response?.ListOfContactPersons[0]
          //         .CustomerContactPersonIDEncrypted
          //     );
          //   }
          // }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getReferredByDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypted: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setReferredByOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
            }))
          );
          if (
            response?.ListOfContactPersons?.length > 0 &&
            ReferenceByIDEncrypted &&
            response?.ListOfContactPersons?.filter(
              (x) =>
                x.CustomerContactPersonIDEncrypted == ReferenceByIDEncrypted
            ).length == 0
          ) {
            formik.setFieldValue("ReferenceByIDEncrypted", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.ListOfContactPersons?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "ReferenceByIDEncrypted",
                response?.ListOfContactPersons[0]
                  .CustomerContactPersonIDEncrypted
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  // const getTPIContactPersonDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetCustomerProjectContactPersonDDLList, {
  //     CustomerIDEncrypted: TPIIDEncrypted,
  //     CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setTPIContactPersonOptions(
  //           response?.ContactPersonDDLList?.map((item) => ({
  //             label: item.ContactPerson,
  //             value: item.CustomerContactPersonIDEncrypted,
  //           }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const getTPIContactPersonDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: TPIIDEncrypted,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPIContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              IsBilling: item.IsBilling,
              IsReporting: item.IsReporting,
              IsDispatch: item.IsDispatch,
              IsDispatchMaterial: item.IsDispatchMaterial,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getEmployeeDDL = async () => {
    setIsLoading(true);
    await post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmployeeOptions(
            response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName,
              value: item.EmployeeIDEncrypted,
            }))
          );
          /*select the value when there is only one option while insert only*/
          if (response?.EmployeeList?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue(
              "MaterialTakenByUserEncrypted",
              response?.EmployeeList[0].EmployeeIDEncrypted
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getSampleReceivedViaDDL = () => {
    setSampleReceivedViaOptions([
      {
        value: 1,
        label: "Hand to Hand",
      },
      {
        value: 2,
        label: "Courier",
        //label: "Post",
      },
    ]);
  };

  // const getDepartmentDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetDepartmentDropDownList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setDepartmentOptions(
  //           response?.List?.map((item) => ({
  //             label: item.DepartmentName,
  //             value: item.DepartmentIDEncrypted,
  //           }))
  //         );

  //         /*select the value when there is only one option while insert only*/
  //         if (response?.List?.length == 1 && !PrimaryIdParam) {
  //           ListOfMaterials?.map((x, i) => {
  //             formik.setFieldValue(
  //               `ListOfMaterials[${i}].DepartmentIDEncrypted`,
  //               response?.List[0].DepartmentIDEncrypted
  //             );
  //             getProductGroupDDL(response?.List[0].DepartmentIDEncrypted, i);
  //           });
  //         }
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  // // const getProductGroupDDL = async (departmentID, index) => {
  // //   if (departmentID) {
  // //     setIsLoading(true);
  // //     await post(POST_ProductGroupDropDownListByDepartmentID, {
  // //       DepartmentIDEncrypt: departmentID,
  // //       CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  // //     })
  // //       .then((response) => {
  // //         if (response?.IsSuccess) {
  // //           formik.setFieldValue(
  // //             `ListOfMaterials[${index}].productGroupOptions`,
  // //             response?.ProductGroupDropDownList?.map((item) => ({
  // //               label: item.ProductGroupName,
  // //               value: item.ProductGroupIDEncrypt,
  // //             }))
  // //           );

  // //           /*select the value when there is only one option while insert only*/
  // //           if (
  // //             response?.ProductGroupDropDownList?.length == 1 &&
  // //             !PrimaryIdParam
  // //           ) {
  // //             formik.setFieldValue(
  // //               `ListOfMaterials[${index}].ProductGroupIDEncrypted`,
  // //               response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt
  // //             );
  // //             getMaterialTypeDDL(
  // //               departmentID,
  // //               response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt,
  // //               index
  // //             );
  // //           }
  // //         }
  // //         setIsLoading(false);
  // //       })
  // //       .catch((error) => {
  // //         console.log(error);
  // //         setIsLoading(false);
  // //       });
  // //   } else {
  // //     formik.setFieldValue(`ListOfMaterials[${index}].productGroupOptions`, []);
  // //     formik.setFieldValue(
  // //       `ListOfMaterials[${index}].ProductGroupIDEncrypted`,
  // //       ""
  // //     );
  // //   }
  // // };

  // const getProductGroupDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_ProductGroupDropDownList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setProductGroupOptions(
  //           response?.ProductGroupDropDownList?.map((item) => ({
  //             label: item.ProductGroupName,
  //             value: item.ProductGroupIDEncrypt,
  //           }))
  //         );

  //         /*select the value when there is only one option while insert only*/
  //         if (
  //           response?.ProductGroupDropDownList?.length == 1 &&
  //           !PrimaryIdParam
  //         ) {
  //           ListOfMaterials?.map((x, i) => {
  //             formik.setFieldValue(
  //               `ListOfMaterials[${i}].ProductGroupIDEncrypted`,
  //               response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt
  //             );
  //             getMaterialTypeDDL(
  //               response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt,
  //               i
  //             );
  //           });
  //         }
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  // // const getMaterialTypeDDL = async (departmentID, productGroupID, index) => {
  // //   if (departmentID && productGroupID) {
  // //     setIsLoading(true);
  // //     await post(POST_GetMaterialTypeDDLListByDepartment_ProductGroup, {
  // //       DepartmentIDEncrypted: departmentID,
  // //       ProductGroupIDEncrypted: productGroupID,
  // //     })
  // //       .then((response) => {
  // //         if (response?.IsSuccess) {
  // //           formik.setFieldValue(
  // //             `ListOfMaterials[${index}].materialTypeOptions`,
  // //             response?.MaterialTypeList?.map((item) => ({
  // //               label: item.MaterialTypeName,
  // //               value: item.MaterialTypeIDEncrypted,
  // //             }))
  // //           );

  // //           /*select the value when there is only one option while insert only*/
  // //           if (response?.MaterialTypeList?.length == 1 && !PrimaryIdParam) {
  // //             formik.setFieldValue(
  // //               `ListOfMaterials[${index}].MaterialTypeIDEncrypted`,
  // //               response?.MaterialTypeList[0].MaterialTypeIDEncrypted
  // //             );
  // //           }
  // //         }
  // //         setIsLoading(false);
  // //       })
  // //       .catch((error) => {
  // //         console.log(error);
  // //         setIsLoading(false);
  // //       });
  // //   } else {
  // //     formik.setFieldValue(`ListOfMaterials[${index}].materialTypeOptions`, []);
  // //     formik.setFieldValue(
  // //       `ListOfMaterials[${index}].MaterialTypeIDEncrypted`,
  // //       ""
  // //     );
  // //   }
  // // };

  // const getMaterialTypeDDL = async (productGroupID, index) => {
  //   if (productGroupID) {
  //     setIsLoading(true);
  //     await post(POST_GetMaterialTypeDDLListByDepartment_ProductGroup, {
  //       ProductGroupIDEncrypted: productGroupID,
  //     })
  //       .then((response) => {
  //         if (response?.IsSuccess) {
  //           formik.setFieldValue(
  //             `ListOfMaterials[${index}].materialTypeOptions`,
  //             response?.MaterialTypeList?.map((item) => ({
  //               label: item.MaterialTypeName,
  //               value: item.MaterialTypeIDEncrypted,
  //             }))
  //           );

  //           /*select the value when there is only one option while insert only*/
  //           if (response?.MaterialTypeList?.length == 1 && !PrimaryIdParam) {
  //             formik.setFieldValue(
  //               `ListOfMaterials[${index}].MaterialTypeIDEncrypted`,
  //               response?.MaterialTypeList[0].MaterialTypeIDEncrypted
  //             );
  //           }
  //         }
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         setIsLoading(false);
  //       });
  //   } else {
  //     formik.setFieldValue(`ListOfMaterials[${index}].materialTypeOptions`, []);
  //     formik.setFieldValue(
  //       `ListOfMaterials[${index}].MaterialTypeIDEncrypted`,
  //       ""
  //     );
  //   }
  // };

  const getModeByDDL = () => {
    setModeByOptions([
      {
        value: 1,
        label: "Email",
      },
      {
        value: 2,
        label: "Post",
      },
      {
        value: 3,
        label: "Hand to Hand",
      },
      {
        value: 4,
        label: "Courier",
      },
    ]);
  };

  const getDispatchMaterialModeDDL = () => {
    setDispatchMaterialModeOptions([
      {
        value: 2,
        label: "Post",
      },
      {
        value: 3,
        label: "Hand to Hand",
      },
      {
        value: 4,
        label: "Courier",
      },
    ]);
  };

  const getProjectDDLModeDetails = async (customerID, index) => {
    if (customerID) {
      setIsLoading(true);
      await post(POST_GetCustomerProjectList, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        CustomerIDEncrypt: customerID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfModeDetails[${index}].projectOptions`,
              response?.CustomerProjectDDLList?.map((item) => ({
                label: item.ProjectName,
                value: item.CustomerProjectIDEncrypt,
              }))
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formik.setFieldValue(`ListOfModeDetails[${index}].projectOptions`, []);
      formik.setFieldValue(
        `ListOfModeDetails[${index}].CustomerProjectIDEncrypted`,
        ""
      );
    }
  };

  const getProjectAddressDDL = async (customerID, projectID, index) => {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerProjectAddressDDLList, {
        CustomerIDEncrypted: customerID,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfModeDetails[${index}].projectAddressOptions`,
              response?.ProjectAddressDDLList?.map((item) => ({
                label: item.Address,
                value: item.CustomerProjectAddressIDEncrypted,
              }))
            );
            /*select the value when there is only one option while insert only*/
            if (
              response?.ProjectAddressDDLList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                `ListOfModeDetails[${index}].CustomerProjectAddressIDEncrypted`,
                response?.ProjectAddressDDLList[0]
                  .CustomerProjectAddressIDEncrypted
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formik.setFieldValue(
        `ListOfModeDetails[${index}].projectAddressOptions`,
        []
      );
      formik.setFieldValue(
        `ListOfModeDetails[${index}].CustomerProjectAddressIDEncrypted`,
        ""
      );
    }
  };

  // const getContactPersonDDL = async (customerID, projectID, index) => {
  //   if (customerID && projectID) {
  //     setIsLoading(true);
  //     await post(POST_GetCustomerProjectContactPersonDDLList, {
  //       CustomerIDEncrypted: customerID,
  //       CustomerProjectIDEncrypted: projectID,
  //     })
  //       .then((response) => {
  //         if (response?.IsSuccess) {
  //           formik.setFieldValue(
  //             `ListOfModeDetails[${index}].contactPersonOptions`,
  //             response?.ContactPersonDDLList?.map((item) => ({
  //               label: item.ContactPerson,
  //               value: item.CustomerContactPersonIDEncrypted,
  //             }))
  //           );
  //           /*select the value when there is only one option while insert only*/
  //           if (
  //             response?.ContactPersonDDLList?.length == 1 &&
  //             !PrimaryIdParam
  //           ) {
  //             formik.setFieldValue(
  //               `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
  //               response?.ContactPersonDDLList[0]
  //                 .CustomerContactPersonIDEncrypted
  //             );
  //           }
  //         }
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         setIsLoading(false);
  //       });
  //   } else {
  //     formik.setFieldValue(
  //       `ListOfModeDetails[${index}].contactPersonOptions`,
  //       []
  //     );
  //     formik.setFieldValue(
  //       `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
  //       ""
  //     );
  //   }
  // };

  const getContactPersonDDL = async (customerID, projectID, index) => {
    // if (customerID) {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerContactPersonDDLByCustomerProject, {
        CustomerIDEncrypted: customerID,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue(
              `ListOfModeDetails[${index}].contactPersonOptions`,
              response?.ListOfContactPersons?.map((item) => ({
                label: item?.ContactPerson,
                value: item?.CustomerContactPersonIDEncrypted,
                IsBilling: item?.IsBilling,
                IsReporting: item?.IsReporting,
                IsDispatch: item?.IsDispatch,
                IsDispatchMaterial: item?.IsDispatchMaterial,
              }))
            );
            /*select the value when there is only one option while insert only*/
            if (
              response?.ListOfContactPersons?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
                response?.ListOfContactPersons[0]
                  .CustomerContactPersonIDEncrypted
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formik.setFieldValue(
        `ListOfModeDetails[${index}].contactPersonOptions`,
        []
      );
      formik.setFieldValue(
        `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
        ""
      );
    }
  };

  const getCustomerReviewList = async () => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 7, //Customer Review
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfReviews",
            response?.List?.map((item) => ({
              InwardReviewIDEncrypted: "",
              Review: item.CategoryName,
              CategoryID: item.CategoryID,
              StatusOfReview: false,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectWorkDetailList = async () => {
    setIsLoading(true);
    post(POST_GetMaterialInwardProjectWorkDetailDDLList, {
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikWorkDetail.setFieldValue(
            "projectWorkDetailList",
            response?.ProjectWorkDetailDDLList?.map((item) => ({
              WorkDetail: item.ProjectDetails,
              IsSelected: false,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const initMaterialInformation = {
    id: "",
    TCNoAllocated: false,
    InwardMaterialIDEncrypted: "",
    TCNo: "",
    ULRNo: "",
    // DepartmentIDEncrypted: "",
    // ProductGroupIDEncrypted: "",
    // MaterialTypeIDEncrypted: "",
    Size: "",
    Condition: "",
    SampleDetail: "",
    ListOfMaterialPhotos: [],
    // productGroupOptions: [],
    // materialTypeOptions: [],
    IsDeleted: false,
    IsErrorDisplay: false,
    IsHeaderDetailMaterialInformationChange: false,
  };

  const initModeDetails = [
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 1,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 2,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 3,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
    {
      InwardModeDetailIDEncrypted: "",
      InwardIDEncrypted: "",
      ModeDetailID: 4,
      ModeType: 0,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerContactPersonIDEncrypted: "",
      projectOptions: [],
      projectAddressOptions: [],
      contactPersonOptions: [],
    },
  ];

  const validationSchema = Yup.object().shape({
    btnSubmitType: Yup.number(),
    InwardNo: Yup.string().when("btnSubmitType", ([btnSubmitType], schema) => {
      if (btnSubmitType != 1)
        return Yup.string().required("Inward No is required field");
      return schema;
    }),
    InwardDate: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Inward Date is required field");
        return schema;
      }
    ),
    CustomerIDEncrypted: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Customer is required field");
        return schema;
      }
    ),
    CustomerProjectIDEncrypted: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Project is required field");
        return schema;
      }
    ),
    // ProjectDetails: Yup.string().when(
    //   "btnSubmitType",
    //   ([btnSubmitType], schema) => {
    //     if (btnSubmitType != 1)
    //       return Yup.string().trim().required("Work Detail is required field");
    //     return schema;
    //   }
    // ),
    ChangeReason: Yup.string().when(
      "IsEditMaterialInwardHeaderDetail",
      ([IsEditMaterialInwardHeaderDetail], schema) => {
        if (IsEditMaterialInwardHeaderDetail == true)
          return Yup.string().required("Change Reason is required field");
        return schema;
      }
    ),
    CustomerProjectName: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1 && !CustomerProjectIDEncrypted)
          return Yup.string().required("Project is required field");
        return schema;
      }
    ),

    InwardIDsClubing: Yup.array().when(
      "InwardClubing",
      ([InwardClubing], schema) => {
        if (InwardClubing == true)
          return Yup.array()
            .required("Inward No is required field")
            .min(1, "Inward No is required field")
            .nullable();
        return schema;
      }
    ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      InwardIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      InwardNo: "",
      InwardDate: new Date(),
      InwardCurrentStatus: 1,
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectName: "",
      ProjectDetails: "",
      LetterRefNo: "",
      StampWriteUpIDEncrypted: "",
      StampImageFilePath: "",
      MaterialReceiveViaID: "",
      ReceiveRemarks: "",
      MaterialTakenByUserEncrypted: "",
      ExpectedDateOfDelivery: "",
      EDDRemarks: "",
      ReferenceByIDEncrypted: "",
      IsMaterialReturnable: false,
      IsTPIRequired: false,
      ListOfLetterRefDoc: [],
      ListOfTPIDetails: [],
      ListOfMaterials: [initMaterialInformation],
      ListOfModeDetails: initModeDetails,
      ListOfReviews: [],
      selectedMaterialInfoRow: -1,
      btnSubmitType: 1, // 1 = Draft, 2 = Submit
      IsStampImageFileDeleted: false,
      IsTCNoBasedOnInwardNo: true,
      IsEditMaterialInwardHeaderDetail: editHeaderInwardIdParam ? true : false,
      AllowToChangeCustomerAndProject: true,
      IsHeaderDetailCustomerChange: false,
      originalCustomerID: "",
      originalCustomerName: "",
      IsHeaderDetailProjectChange: false,
      originalProjectID: "",
      originalProjectName: "",
      IsMaterialDispatched: false,
      IsHeaderDetailWorkDetailChange: false,
      originalWorkDetail: "",
      IsHeaderDetailLetterRefNoChange: false,
      originalLetterRefNo: "",
      // IsHeaderDetailTPIRequiredChange: false,
      // originalIsTPIRequired: false,
      // IsHeaderDetailTPIDetailChange: false,
      // originalListOfTPIDetails: [],
      originalListOfMaterials: [],
      ChangeReason: "",
      InwardClubing: false,
      InwardIDsClubing: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardNo,
      InwardDate,
      InwardCurrentStatus,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      CustomerProjectName,
      IsMaterialReturnable,
      IsTPIRequired,
      ListOfReviews,
      ListOfLetterRefDoc,
      ListOfTPIDetails,
      ListOfMaterials,
      selectedMaterialInfoRow,
      ListOfModeDetails,
      StampWriteUpIDEncrypted,
      ReferenceByIDEncrypted,
      IsTCNoBasedOnInwardNo,
      AllowToChangeCustomerAndProject,
      InwardClubing,
      InwardIDsClubing,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (values?.btnSubmitType == 2) {
      if (ListOfMaterials?.filter((x) => x.IsDeleted == false)?.length == 0) {
        formik.setFieldError(
          "ListOfMaterials",
          "Material Information is required"
        );
        formik.setFieldTouched("ListOfMaterials", true);

        return;
      } else {
        let IsmaterialInfoValid = true;

        Promise.all(
          ListOfMaterials?.filter((x) => x.IsDeleted == false)?.map(
            (item, indx) => {
              if (
                // !item?.DepartmentIDEncrypted ||
                // !item?.ProductGroupIDEncrypted ||
                // !item?.MaterialTypeIDEncrypted ||
                !item?.Size?.trim() ||
                !item?.Condition?.trim() ||
                !item?.SampleDetail?.trim()
              ) {
                IsmaterialInfoValid = false;
              }
            }
          )
        );

        let newList = [];
        newList = ListOfMaterials?.filter((x) => x.IsDeleted == false)?.map(
          (item, indx) => {
            if (
              // !item?.DepartmentIDEncrypted ||
              // !item?.ProductGroupIDEncrypted ||
              // !item?.MaterialTypeIDEncrypted ||
              !item?.Size?.trim() ||
              !item?.Condition?.trim() ||
              !item?.SampleDetail?.trim()
            ) {
              return {
                ...item,
                IsErrorDisplay: true,
              };
            } else {
              return {
                ...item,
                IsErrorDisplay: false,
              };
            }
          }
        );

        formik.setFieldValue("ListOfMaterials", newList);

        if (IsmaterialInfoValid == false) {
          // errorMessage(
          //   "Please fill all the above details of Material Information..."
          // );
          setTimeout(() => {
            formik.setFieldError(
              "ListOfMaterials",
              "Please fill all the above details of Material Information..."
            );
            formik.setFieldTouched("ListOfMaterials", true);
          }, 800);

          return;
        }
      }
    }

    //console.log("payload", values);

    setIsLoading(true);
    let formData = new FormData();
    formData.append("InwardIDEncrypted", values?.InwardIDEncrypt);
    formData.append("InwardNo", values?.InwardNo);
    formData.append(
      "InwardDate",
      values?.InwardDate
        ? moment(values?.InwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : ""
    );
    formData.append("InwardCurrentStatus", values?.btnSubmitType);
    formData.append("CustomerIDEncrypted", values?.CustomerIDEncrypted);
    formData.append(
      "CustomerProjectIDEncrypted",
      values?.CustomerProjectIDEncrypted
    );
    formData.append("IsMaterialReturnable", values?.IsMaterialReturnable);
    formData.append("StampWriteUpIDEncrypted", values?.StampWriteUpIDEncrypted);
    formData.append("StampImageFile", stampImageFile ?? "");
    formData.append("StampImageFilePath", values?.StampImageFilePath);
    formData.append("IsStampImageFileDeleted", values?.IsStampImageFileDeleted);
    formData.append("ProjectDetails", values?.ProjectDetails.trim());
    formData.append("LetterRefNo", values?.LetterRefNo);
    formData.append("IsTPIRequired", values?.IsTPIRequired);
    formData.append("MaterialReceiveViaID", values?.MaterialReceiveViaID);
    formData.append("ReceiveRemarks", values?.ReceiveRemarks);
    formData.append(
      "MaterialTakenByUserEncrypted",
      values?.MaterialTakenByUserEncrypted
    );
    formData.append(
      "ExpectedDateOfDelivery",
      values?.ExpectedDateOfDelivery
        ? moment(values?.ExpectedDateOfDelivery)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : ""
    );
    formData.append("EDDRemarks", values?.EDDRemarks);
    formData.append("ReferenceByIDEncrypted", values?.ReferenceByIDEncrypted);

    Promise.all(
      //ListOfLetterRefDoc
      values?.ListOfLetterRefDoc?.map((x, i) => {
        formData.append(
          `ListOfLetterRefDoc[${i}].InwardLetterRefImageIDEncrypted`,
          x.InwardLetterRefImageIDEncrypted
        );
        formData.append(
          `ListOfLetterRefDoc[${i}].LetterRefImageFile`,
          x.LetterRefImageFile
        );
        formData.append(
          `ListOfLetterRefDoc[${i}].LetterRefImageFilePath`,
          x.LetterRefImageFilePath
        );
        formData.append(`ListOfLetterRefDoc[${i}].IsDeleted`, x.IsDeleted);
      })
    );

    Promise.all(
      //ListOfTPIDetails
      values?.ListOfTPIDetails?.map((x, i) => {
        formData.append(
          `ListOfTPIDetails[${i}].InwardTPIDetailIDEncrypted`,
          x.InwardTPIDetailIDEncrypted
        );
        formData.append(
          `ListOfTPIDetails[${i}].TPIIDEncrypted`,
          x.TPIIDEncrypted
        );
        formData.append(
          `ListOfTPIDetails[${i}].TPIContactPersonIDEncrypted`,
          x.TPIContactPersonIDEncrypted
        );
        formData.append(
          `ListOfTPIDetails[${i}].TPIExpectedDate`,
          x.TPIExpectedDate
            ? moment(x.TPIExpectedDate).format("YYYY-MM-DD").replace(/^\-/, "")
            : ""
        );
        formData.append(`ListOfTPIDetails[${i}].IsDeleted`, x.IsDeleted);
      })
    );

    Promise.all(
      //ListOfMaterials
      values?.ListOfMaterials?.map((x, i) => {
        /* set the id for Material List & it's image list */
        formData.append(`ListOfMaterials[${i}].id`, i + 1);
        formData.append(
          `ListOfMaterials[${i}].InwardMaterialIDEncrypted`,
          x.InwardMaterialIDEncrypted
        );
        // formData.append(
        //   `ListOfMaterials[${i}].DepartmentIDEncrypted`,
        //   x.DepartmentIDEncrypted
        // );
        formData.append(`ListOfMaterials[${i}].TCNo`, x.TCNo);
        // formData.append(
        //   `ListOfMaterials[${i}].ProductGroupIDEncrypted`,
        //   x.ProductGroupIDEncrypted
        // );
        // formData.append(
        //   `ListOfMaterials[${i}].MaterialTypeIDEncrypted`,
        //   x.MaterialTypeIDEncrypted
        // );
        formData.append(`ListOfMaterials[${i}].Size`, x.Size);
        formData.append(`ListOfMaterials[${i}].Condition`, x.Condition);
        formData.append(`ListOfMaterials[${i}].SampleDetail`, x.SampleDetail);
        formData.append(`ListOfMaterials[${i}].IsDeleted`, x.IsDeleted);
        x?.ListOfMaterialPhotos?.map((y, j) => {
          formData.append(
            `ListOfMaterials[${i}].ListOfMaterialPhotos[${j}].id`,
            i + 1
          );
          formData.append(
            `ListOfMaterials[${i}].ListOfMaterialPhotos[${j}].InwardMaterialPhotoIDEncrypted`,
            y.InwardMaterialPhotoIDEncrypted
          );
          formData.append(
            `ListOfMaterials[${i}].ListOfMaterialPhotos[${j}].MaterialPhotoFile`,
            y.MaterialPhotoFile
          );
          formData.append(
            `ListOfMaterials[${i}].ListOfMaterialPhotos[${j}].MaterialPhotoFilePath`,
            y.MaterialPhotoFilePath
          );
          formData.append(
            `ListOfMaterials[${i}].ListOfMaterialPhotos[${j}].IsDeleted`,
            y.IsDeleted
          );
        });
        if (editHeaderInwardIdParam) {
          formData.append(
            `ListOfMaterials[${i}].IsHeaderDetailMaterialInformationChange`,
            x.IsHeaderDetailMaterialInformationChange
          );
        }
      })
    );

    Promise.all(
      //ListOfModeDetails
      values?.ListOfModeDetails?.map((x, i) => {
        /*Save Dispatch Mode = 4 only if Material is returnable*/
        if (
          x.ModeDetailID != 4 ||
          (x.ModeDetailID == 4 && values?.IsMaterialReturnable == true)
        ) {
          formData.append(
            `ListOfModeDetails[${i}].InwardModeDetailIDEncrypted`,
            x.InwardModeDetailIDEncrypted
          );
          formData.append(
            `ListOfModeDetails[${i}].ModeDetailID`,
            x.ModeDetailID
          );
          formData.append(`ListOfModeDetails[${i}].ModeType`, x.ModeType);
          formData.append(
            `ListOfModeDetails[${i}].CustomerIDEncrypted`,
            x.CustomerIDEncrypted
          );
          formData.append(
            `ListOfModeDetails[${i}].CustomerProjectIDEncrypted`,
            x.CustomerProjectIDEncrypted
          );
          formData.append(
            `ListOfModeDetails[${i}].CustomerProjectAddressIDEncrypted`,
            x.CustomerProjectAddressIDEncrypted
          );
          formData.append(
            `ListOfModeDetails[${i}].CustomerContactPersonIDEncrypted`,
            x.CustomerContactPersonIDEncrypted
          );
        }
      })
    );

    Promise.all(
      //ListOfReviews
      values?.ListOfReviews?.map((x, i) => {
        formData.append(
          `ListOfReviews[${i}].InwardReviewIDEncrypted`,
          x.InwardReviewIDEncrypted
        );
        formData.append(`ListOfReviews[${i}].CategoryID`, x.CategoryID);
        formData.append(`ListOfReviews[${i}].StatusOfReview`, x.StatusOfReview);
      })
    );

    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
    formData.append(
      "CreatedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );
    formData.append(
      "ModifiedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );

    formData.append("IsCopyInward", CopyInwardIdParam ? true : false);
    formData.append("IsInwardNoClubing", values?.InwardClubing);
    formData.append(
      "InwardIDsClubing",
      Array.from(values?.InwardIDsClubing, (x) => x.value).join(",")
    );

    if (editHeaderInwardIdParam) {
      formData.append(
        "IsHeaderDetailCustomerChange",
        values?.IsHeaderDetailCustomerChange
      );
      formData.append(
        "IsHeaderDetailProjectChange",
        values?.IsHeaderDetailProjectChange
      );
      formData.append(
        "IsHeaderDetailWorkDetailChange",
        values?.IsHeaderDetailWorkDetailChange
      );
      formData.append(
        "IsHeaderDetailLetterRefNoChange",
        values?.IsHeaderDetailLetterRefNoChange
      );
      formData.append("ChangeReason", values?.ChangeReason);

      postFormData(POST_MaterialInwardHeaderDetailChange, formData)
        .then((response) => {
          setIsLoading(true);
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setTimeout(() => {
              navigate("/material-inward");
            }, 1000);
          } else {
            errorMessage(response?.Message);
            setIsLoading(false);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      postFormData(
        PrimaryIdParam ? POST_MaterialInwardUpdate : POST_MaterialInwardInsert,
        formData
      )
        .then((response) => {
          setIsLoading(true);
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setTimeout(() => {
              navigate("/material-inward");
            }, 1000);
          } else {
            errorMessage(response?.Message);
            setIsLoading(false);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (!InwardDate) {
      formik.setFieldValue("InwardDate", "");
    }
    if (InwardCurrentStatus == 1) {
      getInwardNoDDL();
    }
    getTCNoDDL();
  }, [InwardDate]);

  useEffect(() => {
    if (CustomerIDEncrypted) {
      //formik.setFieldValue("CustomerProjectIDEncrypted", "");
      getProjectDDL(CustomerIDEncrypted);
      getInwardNoClubingDDLList(CustomerIDEncrypted);
    } else {
      setProjectOptions([]);
      formik.setFieldValue("CustomerProjectIDEncrypted", "");
      formik.setFieldValue("CustomerProjectName", "");
    }
    if (CustomerIDEncrypted && CustomerProjectIDEncrypted) {
      //formik.setFieldValue("StampWriteUpIDEncrypted", "");
      //formik.setFieldValue("ReferenceByIDEncrypted", "");
      getStampWriteUpDDL();
      getProjectWorkDetailList();
    } else {
      setStampWriteUpOptions([]);
      formik.setFieldValue("StampWriteUpIDEncrypted", "");
      formik.setFieldValue("ReferenceByIDEncrypted", "");
      formikWorkDetail.setFieldValue("projectWorkDetailList", []);
    }
  }, [CustomerIDEncrypted]);

  useEffect(() => {
    if (CustomerIDEncrypted && CustomerProjectIDEncrypted) {
      //formik.setFieldValue("StampWriteUpIDEncrypted", "");
      //formik.setFieldValue("ReferenceByIDEncrypted", "");
      getStampWriteUpDDL();
      getProjectWorkDetailList();

      if (!PrimaryIdParam && !CopyInwardIdParam && !editHeaderInwardIdParam) {
        /*Only in add b'coz edit mode it's effect the other fields */
        /*Set Inward selected Customer & Project to Mode Details List*/
        ListOfModeDetails?.map((item, index) => {
          //if (!item.CustomerIDEncrypted) {
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerIDEncrypted`,
            CustomerIDEncrypted
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerName`,
            CustomerName
          );
          //}
          //if (!item.CustomerProjectIDEncrypted) {
          formik.setFieldValue(
            `ListOfModeDetails[${index}].projectOptions`,
            projectOptions
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerProjectIDEncrypted`,
            CustomerProjectIDEncrypted
          );
          getProjectAddressDDL(
            CustomerIDEncrypted,
            CustomerProjectIDEncrypted,
            index
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerProjectAddressIDEncrypted`,
            ""
          );
          getContactPersonDDL(
            CustomerIDEncrypted,
            CustomerProjectIDEncrypted,
            index
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerContactPersonIDEncrypted`,
            ""
          );
          //}
        });
      }
    } else {
      setStampWriteUpOptions([]);
      formik.setFieldValue("StampWriteUpIDEncrypted", "");
      formik.setFieldValue("ReferenceByIDEncrypted", "");
      formikWorkDetail.setFieldValue("projectWorkDetailList", []);

      if (!PrimaryIdParam) {
        /*Only in add b'coz edit mode it's effect the other fields */
        /*Set Inward selected Customer & Project to Mode Details List*/
        ListOfModeDetails?.map((item, index) => {
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerIDEncrypted`,
            ""
          );
          formik.setFieldValue(`ListOfModeDetails[${index}].CustomerName`, "");
          formik.setFieldValue(
            `ListOfModeDetails[${index}].projectOptions`,
            []
          );
          formik.setFieldValue(
            `ListOfModeDetails[${index}].CustomerProjectIDEncrypted`,
            ""
          );
          getProjectAddressDDL("", "", index);
          getContactPersonDDL("", "", index);
        });
      }
    }
  }, [CustomerProjectIDEncrypted]);

  const getMaterialInwardDetailByID = async (inwardID) => {
    setIsLoading(true);
    await post(POST_GetMaterialInwardDetailByID, {
      InwardIDEncrypted: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            InwardIDEncrypt: response?.InwardIDEncrypted,

            InwardClubing: response?.IsInwardNoClubing,
            InwardIDsClubing: response?.ListOfInwardNoClubing?.map((item) => ({
              label: item.InwardNo,
              value: item.MainInwardIDEncrypted,
            })),

            InwardDate: response?.InwardDate
              ? new Date(response?.InwardDate)
              : "",
            ExpectedDateOfDelivery: response?.ExpectedDateOfDelivery
              ? new Date(response?.ExpectedDateOfDelivery)
              : "",
            ListOfLetterRefDoc: response?.ListOfLetterRefDoc?.map((x) => {
              return {
                ...x,
                LetterRefImageFile: "",
                viewFile: "",
                LetterRefImageFileName: x?.LetterRefImageFileName,
                // LetterRefImageFileName: x?.LetterRefImageFilePath
                //   ? (x?.LetterRefImageFilePath?.split("/"))[
                //       x?.LetterRefImageFilePath?.split("/").length - 1
                //     ]
                //   : "",
                IsDeleted: false,
              };
            }),
            ListOfTPIDetails: response?.ListOfTPIDetails?.map((x) => {
              return {
                ...x,
                TPIExpectedDate: x?.TPIExpectedDate
                  ? new Date(x?.TPIExpectedDate)
                  : "",
                displayTPIExpectedDate: x?.TPIExpectedDate,
                IsDeleted: false,
              };
            }),
            ListOfMaterials: response?.ListOfMaterials?.map((x, i) => {
              return {
                ...x,
                TCNoAllocated: x?.TCNo ? true : false,
                id: i + 1,
                ListOfMaterialPhotos: x.ListOfMaterialPhotos?.map((y, j) => {
                  return {
                    ...y,
                    id: i + 1,
                    viewFile: "",
                    MaterialPhotoFile: "",
                    IsDeleted: false,
                  };
                }),
                // // productGroupOptions: [], //get the options through api
                // materialTypeOptions: [], //get the options through api
                IsDeleted: false,
                IsErrorDisplay: false,
                IsHeaderDetailMaterialInformationChange: false,
              };
            }),
            ListOfModeDetails: response?.ListOfModeDetails?.map((x) => {
              return {
                ...x,
                projectOptions: [], //get the options through api
                projectAddressOptions: [], //get the options through api
                contactPersonOptions: [], //get the options through api
              };
            }),
            selectedMaterialInfoRow: -1,
            btnSubmitType: 1, // 1 = Draft, 2 = Submit
            IsStampImageFileDeleted: false,
            IsEditMaterialInwardHeaderDetail: editHeaderInwardIdParam
              ? true
              : false,
            IsHeaderDetailCustomerChange: false,
            originalCustomerID: response?.CustomerIDEncrypted,
            originalCustomerName: response?.CustomerName,
            IsHeaderDetailProjectChange: false,
            originalProjectID: response?.CustomerProjectIDEncrypted,
            originalProjectName: response?.CustomerProjectName,
            IsHeaderDetailWorkDetailChange: false,
            originalWorkDetail: response?.ProjectDetails,
            IsHeaderDetailLetterRefNoChange: false,
            originalLetterRefNo: response?.LetterRefNo,
            // IsHeaderDetailTPIRequiredChange: false,
            // originalIsTPIRequired: response?.IsTPIRequired,
            // IsHeaderDetailTPIDetailChange: false,
            // originalListOfTPIDetails: response?.ListOfTPIDetails?.map((x) => {
            //   return {
            //     ...x,
            //     TPIExpectedDate: x?.TPIExpectedDate
            //       ? new Date(x?.TPIExpectedDate)
            //       : "",
            //     displayTPIExpectedDate: x?.TPIExpectedDate,
            //     IsDeleted: false,
            //   };
            // }),
            originalListOfMaterials: response?.ListOfMaterials?.map((x, i) => {
              return {
                ...x,
                TCNoAllocated: x?.TCNo ? true : false,
                id: i + 1,
                ListOfMaterialPhotos: x.ListOfMaterialPhotos?.map((y, j) => {
                  return {
                    ...y,
                    id: i + 1,
                    viewFile: "",
                    MaterialPhotoFile: "",
                    IsDeleted: false,
                  };
                }),
                // // productGroupOptions: [], //get the options through api
                // materialTypeOptions: [], //get the options through api
                IsDeleted: false,
                IsErrorDisplay: false,
                IsHeaderDetailMaterialInformationChange: false,
              };
            }),
            ChangeReason: "",
          });

          response?.ListOfModeDetails?.map((item, index) => {
            getProjectDDLModeDetails(item.CustomerIDEncrypted ?? "", index);
            getProjectAddressDDL(
              item.CustomerIDEncrypted,
              item.CustomerProjectIDEncrypted,
              index
            );
            getContactPersonDDL(
              item.CustomerIDEncrypted,
              item.CustomerProjectIDEncrypted,
              index
            );
          });
          // response?.ListOfMaterials?.map((item, index) => {
          //   // getProductGroupDDL(item.DepartmentIDEncrypted, index);
          //   // getMaterialTypeDDL(
          //   //   item.DepartmentIDEncrypted,
          //   //   item.ProductGroupIDEncrypted,
          //   //   index
          //   // );
          //   getMaterialTypeDDL(item.ProductGroupIDEncrypted, index);
          // });
          if (response?.StampImageFilePath) {
            setStampImage(response?.StampImageFilePath);
          }
          if (response?.InwardCurrentStatus == 1) {
            getInwardNoDDL();
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCopyInwardDetails = async () => {
    setIsLoading(true);
    await post(POST_GetMaterialInwardDetailByID, {
      InwardIDEncrypted: window.atob(CopyInwardIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "CustomerIDEncrypted",
            response?.CustomerIDEncrypted
          );
          formik.setFieldValue("CustomerName", response?.CustomerName);
          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            response?.CustomerProjectIDEncrypted
          );
          formik.setFieldValue(
            "CustomerProjectName",
            response?.CustomerProjectName
          );
          formik.setFieldValue(
            "ListOfMaterials",
            response?.ListOfMaterials?.map((x, i) => {
              return {
                ...x,
                TCNo: "",
                ULRNo: "",
                TCNoAllocated: false,
                id: i + 1,
                // ListOfMaterialPhotos: x.ListOfMaterialPhotos?.map((y, j) => {
                //   return {
                //     ...y,
                //     id: i + 1,
                //     viewFile: "",
                //     MaterialPhotoFile: "",
                //     IsDeleted: false,
                //   };
                // }),
                ListOfMaterialPhotos: [],
                // // productGroupOptions: [], //get the options through api
                // materialTypeOptions: [], //get the options through api
                IsDeleted: false,
                IsErrorDisplay: false,
                IsHeaderDetailMaterialInformationChange: false,
              };
            })
          );
          formik.setFieldValue(
            "ListOfModeDetails",
            response?.ListOfModeDetails?.map((x) => {
              return {
                ...x,
                projectOptions: [], //get the options through api
                projectAddressOptions: [], //get the options through api
                contactPersonOptions: [], //get the options through api
              };
            })
          );
          response?.ListOfModeDetails?.map((item, index) => {
            getProjectDDLModeDetails(item.CustomerIDEncrypted ?? "", index);
            getProjectAddressDDL(
              item.CustomerIDEncrypted,
              item.CustomerProjectIDEncrypted,
              index
            );
            getContactPersonDDL(
              item.CustomerIDEncrypted,
              item.CustomerProjectIDEncrypted,
              index
            );
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    //getCustomerDDL();
    getTPICustomerDDL();
    // getDepartmentDDL();
    // getProductGroupDDL();
    getModeByDDL();
    getEmployeeDDL();
    getSampleReceivedViaDDL();
    getCustomerReviewList();
    getDispatchMaterialModeDDL();
    getReferredByDDL();

    if (PrimaryIdParam) {
      getMaterialInwardDetailByID(window.atob(PrimaryIdParam));
    } else if (editHeaderInwardIdParam) {
      getMaterialInwardDetailByID(window.atob(editHeaderInwardIdParam));
    } else {
      getInwardNoDDL();
    }

    if (CopyInwardIdParam) {
      getCopyInwardDetails();
    }
  }, []);

  const uploadStampImage = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        setStampImageFile(null);
        setStampImage(null);
        warningMessage("Select valid image file!");
      } else {
        // var reader = new FileReader();
        // reader.readAsDataURL(e.target.files[0]);
        // reader.onload = function (e) {
        //   var image = new Image();
        //   image.src = e.target.result;
        //   image.onload = function () {
        //     var height = this.height;
        //     var width = this.width;
        // if (height !== 200 || width !== 200) {
        //   swal("Error!", "Image size must be of 200x200", "error");
        //   setStampImageFile(null);
        //   setStampImage(null);
        // } else {
        setStampImageFile(file);
        setStampImage(URL.createObjectURL(file));
        // }
        //   };
        // };
      }
      //formik.setFieldValue("StampImageFilePath", "");
    }
  };

  const uploadLetterRefDoc = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      //console.log(file);
      if (file) {
        formik.setFieldValue("ListOfLetterRefDoc", [
          ...ListOfLetterRefDoc,
          {
            InwardLetterRefImageIDEncrypted: "",
            LetterRefImageFile: file,
            viewFile: URL.createObjectURL(file),
            LetterRefImageFileName: file?.name,
            LetterRefImageFilePath: "",
            IsDeleted: false,
          },
        ]);

        //successMessage("Letter Ref Doc Uploaded...");
      }
    }
  };

  const validationSchemaTPIDetail = Yup.object().shape({
    TPIIDEncrypted: Yup.string().required("TPI is required field"),
    TPIContactPersonIDEncrypted: Yup.string().required(
      "TPI Contact Person is required field"
    ),
  });

  const formikTPIDetail = useFormik({
    validationSchema: validationSchemaTPIDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTPIDetail(values, formikHelpers),
    initialValues: {
      TPIIDEncrypted: "",
      TPIContactPersonIDEncrypted: "",
      TPIExpectedDate: "",
      TPIName: "",
      TPIContactPersonName: "",
      displayTPIExpectedDate: "",
      editIndexTPI: "",
      actionFlagTPI: 0, // 0 = Add,  1 = edit
      IsDeleted: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { TPIIDEncrypted, actionFlagTPI },
  } = formikTPIDetail;

  useEffect(() => {
    if (TPIIDEncrypted) {
      //formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
      getTPIContactPersonDDL();
    } else {
      setTPIContactPersonOptions([]);
      formikTPIDetail.setFieldValue("TPIContactPersonIDEncrypted", "");
    }
  }, [TPIIDEncrypted]);

  const handleValidSubmitTPIDetail = (values) => {
    if (values?.editIndexTPI !== "") {
      if (
        ListOfTPIDetails?.filter(
          (x, i) =>
            x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted ==
              values?.TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false &&
            i != values?.editIndexTPI
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
        return;
      } else {
        formik.setFieldValue(
          "ListOfTPIDetails",
          ListOfTPIDetails?.map((x, idx) => {
            if (idx == values?.editIndexTPI) {
              return {
                ...x,
                TPIIDEncrypted: values?.TPIIDEncrypted,
                TPIContactPersonIDEncrypted:
                  values?.TPIContactPersonIDEncrypted,
                TPIExpectedDate: values?.TPIExpectedDate,
                TPIName: values?.TPIName,
                TPIContactPersonName: values?.TPIContactPersonName,
                displayTPIExpectedDate: values?.TPIExpectedDate
                  ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
                  : "",
              };
            } else {
              return { ...x };
            }
          })
        );
      }
    } else {
      if (
        ListOfTPIDetails?.filter(
          (x) =>
            x?.TPIIDEncrypted == values?.TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted ==
              values?.TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
        return;
      } else {
        formik.setFieldValue("ListOfTPIDetails", [
          ...ListOfTPIDetails,
          {
            ...values,
            displayTPIExpectedDate: values?.TPIExpectedDate
              ? moment(values?.TPIExpectedDate).format("DD-MMM-yyyy")
              : "",
          },
        ]);
      }
    }
    setShowAddTPIDetailModal(false);
  };

  const addNewTPI = () => {
    if (CustomerProjectIDEncrypted) {
      formikTPIDetail.resetForm();
      /*select the value when there is only one option while insert only*/
      if (tpiCustomerOptions?.length == 1) {
        formikTPIDetail.setFieldValue(
          "TPIIDEncrypted",
          tpiCustomerOptions[0].value
        );
        formikTPIDetail.setFieldValue("TPIName", tpiCustomerOptions[0].label);
      }
      /*select the value when there is only one option while insert only*/
      if (tpiContactPersonOptions?.length == 1) {
        formikTPIDetail.setFieldValue(
          "TPIContactPersonIDEncrypted",
          tpiContactPersonOptions[0].value
        );
        formikTPIDetail.setFieldValue(
          "TPIContactPersonName",
          tpiContactPersonOptions[0].label
        );
      }
      setShowAddTPIDetailModal(true);
    } else {
      warningMessage("Please select Project first...");
    }
  };

  const editTPI = (i) => {
    let editData = ListOfTPIDetails[i];
    formikTPIDetail.setValues({ ...editData, editIndexTPI: i });
    formikTPIDetail.setFieldValue("actionFlagTPI", 1); // 1 = edit
    setShowAddTPIDetailModal(true);
  };

  const deleteTPI = (i) => {
    if (ListOfTPIDetails[i]?.InwardTPIDetailIDEncrypted) {
      formik.setFieldValue(`ListOfTPIDetails[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfTPIDetails",
        ListOfTPIDetails?.filter((x, ix) => ix != i)
      );
    }
  };

  const AddNewMaterialInformation = () => {
    formik.setFieldValue("ListOfMaterials", [
      ...ListOfMaterials,
      initMaterialInformation,
    ]);

    // /*select the value when there is only one option while insert only*/
    // if (departmentOptions?.length == 1 && !PrimaryIdParam) {
    //   let newIndex = ListOfMaterials?.length;
    //   formik.setFieldValue(
    //     `ListOfMaterials[${newIndex}].DepartmentIDEncrypted`,
    //     departmentOptions[0].value
    //   );
    //   getProductGroupDDL(departmentOptions[0].value, newIndex);
    // }

    // /*select the value when there is only one option while insert only*/
    // if (productGroupOptions?.length == 1 && !PrimaryIdParam) {
    //   let newIndex = ListOfMaterials?.length;
    //   formik.setFieldValue(
    //     `ListOfMaterials[${newIndex}].ProductGroupIDEncrypted`,
    //     productGroupOptions[0].value
    //   );
    // }
  };

  const deleteMaterialInformation = (i) => {
    if (ListOfMaterials[i]?.InwardMaterialIDEncrypted) {
      formik.setFieldValue(`ListOfMaterials[${i}].IsDeleted`, true);
      formik.setFieldValue(
        `ListOfMaterials[${i}].ListOfMaterialPhotos`,
        ListOfMaterials[i]?.ListOfMaterialPhotos?.map((x) => {
          return { ...x, IsDeleted: true };
        })
      );
    } else {
      formik.setFieldValue(
        "ListOfMaterials",
        ListOfMaterials?.filter((x, idx) => idx != i)
      );
    }
  };

  const validationMaterialInfoRepeatRow = Yup.object().shape({
    NoOfRepeatMaterialInfoRow: Yup.number()
      .min(1, "No of Repeat Row is required field")
      .required("No of Repeat Row is required field"),
  });

  const formikMaterialInfoRepeatRow = useFormik({
    validationSchema: validationMaterialInfoRepeatRow,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitMaterialInfoRepeatRow(values, formikHelpers),
    initialValues: {
      NoOfRepeatMaterialInfoRow: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikMaterialInfoRepeatRow;

  const handleValidSubmitMaterialInfoRepeatRow = (values) => {
    setIsLoading(true);
    setTimeout(() => {
      let selectedRow = ListOfMaterials[selectedMaterialInfoRow];
      let newListOfMaterials = ListOfMaterials;
      // for (let i = 0; i < values?.NoOfRepeatMaterialInfoRow; i++) {
      //   newListOfMaterials = [...newListOfMaterials, selectedRow];
      // }
      for (let i = 0; i < values?.NoOfRepeatMaterialInfoRow; i++) {
        newListOfMaterials = [
          ...newListOfMaterials,
          {
            ...selectedRow,
            id: "",
            TCNo: "",
            TCNoAllocated: false,
            InwardMaterialIDEncrypted: "",
            ULRNo: "",
          },
        ];
      }
      formik.setFieldValue("ListOfMaterials", newListOfMaterials);
      setShowMaterialInfoRepeatRowQtyModal(false);
      setIsLoading(false);
    }, 300);
  };

  const [materialPhoto, setMaterialPhoto] = useState(null);
  const [materialPhotoFile, setMaterialPhotoFile] = useState(null);

  const [fileKeyMaterialPhoto, setFileKeyMaterialPhoto] = useState();

  const [zoomMaterialPhoto, setZoomMaterialPhoto] = useState(0.5);

  const [openCropperModalMaterialPhoto, setOpenCropperModalMaterialPhoto] =
    useState(false);
  const [openWebCamModalMaterialImage, setOpenWebCamModalMaterialImage] =
    useState(false);
  const [imageMaterialPhoto, setImageMaterialPhoto] = useState();
  const [cropperMaterialPhoto, setCropperMaterialPhoto] = useState();

  const getCropDataMaterialPhoto = () => {
    if (typeof cropperMaterialPhoto !== "undefined") {
      handleUploadMaterialPhoto(
        cropperMaterialPhoto.getCroppedCanvas().toDataURL()
      );
      setMaterialPhoto(cropperMaterialPhoto.getCroppedCanvas().toDataURL());
    }
  };

  const handleUploadMaterialPhoto = async (url) => {
    const outputFileMaterialPhoto = await dataUrlToFileUsingFetch(
      url,
      "output.png",
      "image/png"
    );
    //const file = dataUrlToFile(url, "output.png");
    setMaterialPhotoFile(outputFileMaterialPhoto);
  };

  const uploadMaterialPhoto = (event) => {
    if (event.target.files.length === 1) {
      var pattern = /image-*/;
      if (event.target.files[0].type.match(pattern)) {
        event.preventDefault();
        let files;
        if (event.dataTransfer) {
          files = event.dataTransfer.files;
        } else if (event.target) {
          files = event.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
          setImageMaterialPhoto(reader.result);
        };
        reader.readAsDataURL(files[0]);
        setOpenCropperModalMaterialPhoto(true);
      } else {
        setMaterialPhotoFile(null);
        setMaterialPhoto(null);
        warningMessage("Select valid image file!");
      }
    }
  };

  const capturePhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setMaterialPhoto(imageSrc);
      const outputFileMaterialPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png"
      );
      setMaterialPhotoFile(outputFileMaterialPhotoCapture);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalMaterialImage(false);
  }, [webcamRef]);

  const onUserMedia = (e) => {
    console.log(e);
  };

  const addMaterialImage = () => {
    //console.log(ListOfMaterials[selectedMaterialInfoRow]);
    formik.setFieldValue(
      `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos`,
      [
        ...ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos,
        {
          id: "",
          InwardMaterialPhotoIDEncrypted: "",
          viewFile: URL.createObjectURL(materialPhotoFile),
          MaterialPhotoFile: materialPhotoFile,
          MaterialPhotoFilePath: "",
          IsDeleted: false,
        },
      ]
    );
    setMaterialPhoto(null);
    setMaterialPhotoFile(null);
  };

  const deleteMaterialImage = (i) => {
    if (
      ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos[i]
        ?.InwardMaterialPhotoIDEncrypted
    ) {
      formik.setFieldValue(
        `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos[${i}].IsDeleted`,
        true
      );
    } else {
      formik.setFieldValue(
        `ListOfMaterials[${selectedMaterialInfoRow}].ListOfMaterialPhotos`,
        ListOfMaterials[selectedMaterialInfoRow]?.ListOfMaterialPhotos?.filter(
          (x, idx) => idx != i
        )
      );
    }
  };

  const formikWorkDetail = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitWorkDetail(values, formikHelpers),
    initialValues: {
      projectWorkDetailList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { projectWorkDetailList },
  } = formikWorkDetail;

  const handleValidSubmitWorkDetail = (values) => {
    formik.setFieldValue(
      "ProjectDetails",
      values?.projectWorkDetailList
        ?.filter((x) => x.IsSelected == true)
        ?.map((wd) => {
          return wd.WorkDetail;
        })
        .join(" ")
    );
    setShowWorkDetailModal(false);
  };

  const [refreshCustomerKey, setRefreshCustomerKey] = useState("0");

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  // const redirectToNewCustomer = () => {
  //   window.open("/add-customer");
  // };

  const deleteLetterRefDoc = (i) => {
    if (ListOfLetterRefDoc[i]?.InwardLetterRefImageIDEncrypted) {
      formik.setFieldValue(`ListOfLetterRefDoc[${i}].IsDeleted`, true);
    } else {
      formik.setFieldValue(
        "ListOfLetterRefDoc",
        ListOfLetterRefDoc?.filter((x, ix) => ix != i)
      );
    }
  };

  const ValidateCustomerCredit = async (customerId) => {
    setIsLoading(true);
    await post(POST_ValidateCustomerCredit, {
      CustomerIDEncrypt: customerId,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess == false) {
          customConfirmDialog(
            response?.Message,
            "Do you want to create more Inwards?",
            fnCallbackValidateCustomerCredit,
            false
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallbackValidateCustomerCredit = () => {
    navigate(-1);
  };

  const [letterRefDocPhoto, setLetterRefDocPhoto] = useState(null);
  const [letterRefDocPhotoFile, setLetterRefDocPhotoFile] = useState(null);
  const [
    openWebCamModalLetterRefDocImage,
    setOpenWebCamModalLetterRefDocImage,
  ] = useState(false);

  const [letterRefDocPhotoFileName, setLetterRefDocPhotoFileName] = useState();

  const addLetterRefDocFile = () => {
    formik.setFieldValue("ListOfLetterRefDoc", [
      ...ListOfLetterRefDoc,
      {
        InwardLetterRefImageIDEncrypted: "",
        LetterRefImageFile: letterRefDocPhotoFile,
        viewFile: URL.createObjectURL(letterRefDocPhotoFile),
        LetterRefImageFileName: letterRefDocPhotoFileName,
        LetterRefImageFilePath: "",
        IsDeleted: false,
      },
    ]);

    setLetterRefDocPhoto(null);
    setLetterRefDocPhotoFile(null);
  };

  const captureLetterRefDocPhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setLetterRefDocPhoto(imageSrc);
      const outputFileLetterRefDocPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png"
      );
      setLetterRefDocPhotoFile(outputFileLetterRefDocPhotoCapture);
      const fileName = outputFileLetterRefDocPhotoCapture.name;
      setLetterRefDocPhotoFileName(fileName);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalLetterRefDocImage(false);
  }, [webcamRef]);

  const handleChangeHeaderDetailCustomerChange = (e) => {
    if (AllowToChangeCustomerAndProject == true) {
      customConfirmDialog(
        `Report Printing ${
          AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
        } transactions will be deleted if they exist.`,
        "Do you want to change Customer?",
        fnCallbackHandleChangeHeaderDetailCustomerChange,
        true
      );
    } else {
      warningMessage(
        "Once an accounting transaction, such as a proforma invoice or an invoice, has been created, it cannot be changed."
      );
    }
  };

  const fnCallbackHandleChangeHeaderDetailCustomerChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailCustomerChange",
      !formik?.values?.IsHeaderDetailCustomerChange
    );
  };

  const cancelHeaderDetailCustomerChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailCustomerChange",
      !formik?.values?.IsHeaderDetailCustomerChange
    );
    if (CustomerIDEncrypted !== formik?.values?.originalCustomerID) {
      formik.setFieldValue(
        "CustomerIDEncrypted",
        formik?.values?.originalCustomerID
      );
      formik.setFieldValue(
        "CustomerName",
        formik?.values?.originalCustomerName
      );
      getProjectDDL(formik?.values?.originalCustomerID);
      formik.setFieldValue(
        "CustomerProjectIDEncrypted",
        formik?.values?.originalProjectID
      );
      formik.setFieldValue(
        "CustomerProjectName",
        formik?.values?.originalProjectName
      );
    }
  };

  const handleChangeHeaderDetailProjectChange = (e) => {
    if (AllowToChangeCustomerAndProject == true) {
      customConfirmDialog(
        `Report Printing ${
          AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
        } transactions will be deleted if they exist.`,
        "Do you want to change Project?",
        fnCallbackHandleChangeHeaderDetailProjectChange,
        true
      );
    } else {
      warningMessage(
        "Once an accounting transaction, such as a proforma invoice or an invoice, has been created, it cannot be changed."
      );
    }
  };

  const fnCallbackHandleChangeHeaderDetailProjectChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailProjectChange",
      !formik?.values?.IsHeaderDetailProjectChange
    );
  };

  const cancelHeaderDetailProjectChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailProjectChange",
      !formik?.values?.IsHeaderDetailProjectChange
    );
    if (CustomerProjectIDEncrypted !== formik?.values?.originalProjectID) {
      formik.setFieldValue(
        "CustomerProjectIDEncrypted",
        formik?.values?.originalProjectID
      );
      formik.setFieldValue(
        "CustomerProjectName",
        formik?.values?.originalProjectName
      );
    }
  };

  const handleChangeHeaderDetailWorkDetailChange = (e) => {
    customConfirmDialog(
      `Report Printing ${
        AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
      } transactions will be deleted if they exist.`,
      "Do you want to change Work Detail?",
      fnCallbackHandleChangeHeaderDetailWorkDetailChange,
      true
    );
  };

  const fnCallbackHandleChangeHeaderDetailWorkDetailChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailWorkDetailChange",
      !formik?.values?.IsHeaderDetailWorkDetailChange
    );
  };

  const cancelHeaderDetailWorkDetailChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailWorkDetailChange",
      !formik?.values?.IsHeaderDetailWorkDetailChange
    );
    if (formik?.values?.ProjectDetails !== formik?.values?.originalWorkDetail) {
      formik.setFieldValue(
        "ProjectDetails",
        formik?.values?.originalWorkDetail
      );
    }
  };

  const handleChangeHeaderDetailLetterRefNoChange = (e) => {
    customConfirmDialog(
      `Report Printing ${
        AuthUser?.Permissions?.UploadScanCopy == 1 ? "& Upload Scan Copy" : ""
      } transactions will be deleted if they exist.`,
      "Do you want to change Letter Ref No?",
      fnCallbackHandleChangeHeaderDetailLetterRefNoChange,
      true
    );
  };

  const fnCallbackHandleChangeHeaderDetailLetterRefNoChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailLetterRefNoChange",
      !formik?.values?.IsHeaderDetailLetterRefNoChange
    );
  };

  const cancelHeaderDetailLetterRefNoChange = () => {
    formik.setFieldValue(
      "IsHeaderDetailLetterRefNoChange",
      !formik?.values?.IsHeaderDetailLetterRefNoChange
    );
    if (formik?.values?.LetterRefNo !== formik?.values?.originalLetterRefNo) {
      formik.setFieldValue("LetterRefNo", formik?.values?.originalLetterRefNo);
    }
  };

  const handleChangeIsTPIRequired = (e) => {
    // if (
    //   editHeaderInwardIdParam &&
    //   !IsTPIRequired !== formik?.values?.originalIsTPIRequired
    // ) {
    //   customConfirmDialog(
    //     `Report Printing & Upload Scan Copy transactions will be deleted if they exist.`,
    //     "Do you want to change TPI Required?",
    //     fnCallbackHandleChangeHeaderDetailIsTPIRequiredChange,
    //     true
    //   );
    // } else {
    formik.setFieldValue("IsTPIRequired", !IsTPIRequired);
    //   formik.setFieldValue("IsHeaderDetailTPIRequiredChange", false);
    //   if (!IsTPIRequired == false) {
    //     formik.setFieldValue("IsHeaderDetailTPIDetailChange", false);
    //   }
    // }
  };

  // const fnCallbackHandleChangeHeaderDetailIsTPIRequiredChange = () => {
  //   formik.setFieldValue("IsTPIRequired", !IsTPIRequired);
  //   formik.setFieldValue("IsHeaderDetailTPIRequiredChange", true);
  //   if (!IsTPIRequired == true) {
  //     formik.setFieldValue("IsHeaderDetailTPIDetailChange", true);
  //   }
  // };

  // const handleChangeHeaderDetailTPIDetailChange = (e) => {
  //   customConfirmDialog(
  //     `Report Printing & Upload Scan Copy transactions will be deleted if they exist.`,
  //     "Do you want to change TPI Details?",
  //     fnCallbackHandleChangeHeaderDetailTPIDetailChange,
  //     true
  //   );
  // };

  // const fnCallbackHandleChangeHeaderDetailTPIDetailChange = () => {
  //   formik.setFieldValue(
  //     "IsHeaderDetailTPIDetailChange",
  //     !formik?.values?.IsHeaderDetailTPIDetailChange
  //   );
  // };

  // const cancelHeaderDetailTPIDetailChange = () => {
  //   formik.setFieldValue(
  //     "IsHeaderDetailTPIDetailChange",
  //     !formik?.values?.IsHeaderDetailTPIDetailChange
  //   );
  //   if (
  //     formik?.values?.ListOfTPIDetails !==
  //     formik?.values?.originalListOfTPIDetails
  //   ) {
  //     formik.setFieldValue(
  //       "ListOfTPIDetails",
  //       formik?.values?.originalListOfTPIDetails
  //     );
  //   }
  // };

  const handleChangeHeaderDetailMaterialInformationChange = (mIndex) => {
    formik.setFieldValue(
      `ListOfMaterials[${mIndex}].IsHeaderDetailMaterialInformationChange`,
      !ListOfMaterials[mIndex].IsHeaderDetailMaterialInformationChange
    );
  };

  const cancelHeaderDetailMaterialInformationChange = (mIndex) => {
    formik.setFieldValue(
      `ListOfMaterials[${mIndex}].IsHeaderDetailMaterialInformationChange`,
      !ListOfMaterials[mIndex].IsHeaderDetailMaterialInformationChange
    );
    if (
      formik?.values?.ListOfMaterials[mIndex] !==
      formik?.values?.originalListOfMaterials[mIndex]
    ) {
      formik.setFieldValue(
        `ListOfMaterials[${mIndex}]`,
        formik?.values?.originalListOfMaterials[mIndex]
      );
    }
  };

  const handleChangeInwardClubing = (e) => {
    formik.setFieldValue("InwardClubing", !InwardClubing);
  };

  const [inwardNoClubingOptions, setInwardNoClubingOptions] = useState([]);

  const getInwardNoClubingDDLList = async (customerID) => {
    if (customerID) {
      setIsLoading(true);
      await post(POST_DDLGetInwardListForInwardClubing, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
        CustomerIDEncrypted: customerID,
        InwardIDEncrypted: PrimaryIdParam
          ? window.atob(PrimaryIdParam)
          : editHeaderInwardIdParam
          ? window.atob(editHeaderInwardIdParam)
          : "",
      })
        .then((response) => {
          if (response?.IsSuccess) {
            setInwardNoClubingOptions(
              response?.ListOfInwardNo?.map((item) => ({
                label: item.InwardNo,
                value: item.InwardIDEncrypted,
              }))
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setInwardNoClubingOptions([]);
      formik.setFieldValue("InwardIDsClubing", []);
    }
  };

  const handleChangeInwardNos = (e) => {
    let inwards = e ?? [];
    formik.setFieldValue("InwardIDsClubing", inwards);
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam || editHeaderInwardIdParam ? "Edit" : "Add"}{" "}
              Material Inward
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={9}>
                    <Row>
                      <Col lg={4}>
                        {InwardCurrentStatus == 1 ? (
                          <Field
                            label="Inward Date"
                            name="InwardDate"
                            placeholder={"Select Inward Date"}
                            component={CustomFlatpickr}
                            options={{
                              altInput: true,
                              altFormat: "j-M-Y",
                              dateFormat: "d-m-Y",
                              maxDate: new Date(),
                            }}
                            required
                          />
                        ) : (
                          <Field
                            label="Inward Date"
                            name="InwardDate"
                            component={CustomInput}
                            value={moment(InwardDate).format("DD-MMM-yyyy")}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={4}>
                        {InwardCurrentStatus == 1 ? (
                          <Field
                            label="Inward No"
                            name="InwardNo"
                            placeholder={"Select Inward No"}
                            options={inwardNoOptions}
                            component={CustomSelect}
                            required
                            autoFocus
                            onChange={(e) => {
                              console.log(e);
                              formik.setFieldValue("InwardNo", e?.value ?? "");
                              formik.setFieldValue(
                                "IsTCNoBasedOnInwardNo",
                                e ? e?.IsTCNoBasedOnInwardNo : true
                              );
                            }}
                          />
                        ) : (
                          <Field
                            label="Inward No"
                            name="InwardNo"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                        <Col lg={4}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex mb-2">
                            <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 mb-1 me-1">
                              <label className="mb-1">
                                Sample Returnable &nbsp;
                              </label>
                            </text>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckIsMaterialReturnable"
                                title={
                                  IsMaterialReturnable == true ? "Yes" : "No"
                                }
                                checked={IsMaterialReturnable}
                                onChange={() => {
                                  if (
                                    editHeaderInwardIdParam &&
                                    formik?.values?.IsMaterialDispatched ==
                                      true &&
                                    IsMaterialReturnable == true
                                  ) {
                                    warningMessage(
                                      "The sample has been dispatched, it cannot be changed."
                                    );
                                  } else {
                                    formik.setFieldValue(
                                      "IsMaterialReturnable",
                                      !IsMaterialReturnable
                                    );
                                  }
                                }}
                                style={{ cursor: "pointer" }}
                              ></input>
                            </div>
                          </div>
                        </Col>
                      ) : (
                        <Col lg={4}></Col>
                      )}
                      <Col lg={4}>
                        {/* <Field
                          label="Customer"
                          name="CustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          options={customerOptions}
                          component={CustomSelect}
                          required
                        /> */}
                        {!PrimaryIdParam && !editHeaderInwardIdParam ? (
                          <>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 10 && x?.IsAdd
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                className="icon-box icon-box-md bg-primary-light me-1"
                                title="New Customer"
                                style={{ float: "right" }}
                                // onClick={() => {
                                //   redirectToNewCustomer();
                                // }}
                                onClick={() => {
                                  window.open(
                                    `/add-customer/${true}`,
                                    "_blank"
                                  );
                                }}
                              >
                                <i className="fa fa-plus"></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="Reload Customer"
                              style={{ float: "right" }}
                              onClick={() => {
                                // loadOptionsCutomer("");
                                setRefreshCustomerKey(
                                  Math.random().toString(9).substring(2, 9)
                                );
                              }}
                            >
                              <i className="fa fa-refresh"></i>
                            </Link>
                          </>
                        ) : (
                          ""
                        )}
                        {editHeaderInwardIdParam ? (
                          formik?.values?.IsHeaderDetailCustomerChange ==
                          false ? (
                            <Link
                              to="#"
                              className="me-1"
                              title="Edit"
                              style={{ float: "right" }}
                              onClick={handleChangeHeaderDetailCustomerChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Edit
                              </label>
                            </Link>
                          ) : (
                            <Link
                              to="#"
                              className="me-1"
                              title="Cancel"
                              style={{ float: "right" }}
                              onClick={cancelHeaderDetailCustomerChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Cancel
                              </label>
                            </Link>
                          )
                        ) : (
                          ""
                        )}

                        {editHeaderInwardIdParam &&
                        formik?.values?.IsHeaderDetailCustomerChange ==
                          false ? (
                          <Field
                            label="Customer"
                            name="CustomerName"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        ) : (
                          <Field
                            key={refreshCustomerKey}
                            label="Customer"
                            name="CustomerIDEncrypted"
                            placeholder={"Select Customer"}
                            //options={customerOptions}
                            loadOptionsFn={loadOptionsCutomer}
                            component={CustomSelectAsync}
                            title={CustomerName}
                            labelFieldName="CustomerName"
                            onChange={(e) => {
                              formik.setFieldValue(
                                "CustomerIDEncrypted",
                                e?.value ?? ""
                              );
                              formik.setFieldValue(
                                "CustomerName",
                                e?.label ?? ""
                              );
                              if (e && e?.value && !editHeaderInwardIdParam) {
                                ValidateCustomerCredit(e?.value);
                              }
                            }}
                            required
                          />
                        )}
                      </Col>
                      <Col lg={4}>
                        {editHeaderInwardIdParam ? (
                          formik?.values?.IsHeaderDetailProjectChange ==
                          false ? (
                            <Link
                              to="#"
                              className="me-1"
                              title="Edit"
                              style={{ float: "right" }}
                              onClick={handleChangeHeaderDetailProjectChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Edit
                              </label>
                            </Link>
                          ) : (
                            <Link
                              to="#"
                              className="me-1"
                              title="Cancel"
                              style={{ float: "right" }}
                              onClick={cancelHeaderDetailProjectChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Cancel
                              </label>
                            </Link>
                          )
                        ) : (
                          ""
                        )}

                        {editHeaderInwardIdParam &&
                        formik?.values?.IsHeaderDetailProjectChange == false ? (
                          <Field
                            label="Project"
                            name="CustomerProjectName"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        ) : (
                          <Field
                            label="Project"
                            name="CustomerProjectIDEncrypted"
                            placeholder={"Select Project"}
                            options={projectOptions}
                            component={CustomSelect}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "CustomerProjectIDEncrypted",
                                e?.value ?? ""
                              );
                              formik.setFieldValue(
                                "CustomerProjectName",
                                e?.label ?? ""
                              );
                            }}
                            required
                          />
                        )}
                      </Col>
                      <Col lg={4}>
                        <Field
                          label="Stamp"
                          name="StampWriteUpIDEncrypted"
                          placeholder={"Select Stamp"}
                          options={stampWriteUpOptions}
                          component={CustomSelect}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={3}>
                    <label className="mb-1">
                      Stamp Image
                      {/* <span className="text-danger">*</span>*/}
                      {/* {" "} <span className="text-danger fs-12">(200 x 200)</span> */}
                    </label>
                    <div className="image-placeholder square-placeholder">
                      <div className="avatar-edit">
                        <input
                          type="file"
                          id="imageUpload"
                          accept="image/png, image/gif, image/jpeg"
                          onChange={uploadStampImage}
                        />
                        <label htmlFor="imageUpload" name=""></label>
                      </div>
                      <div
                        id="removeFile"
                        className="avatar-delete"
                        onClick={() => {
                          setStampImageFile(null);
                          setStampImage(null);
                          //formik.setFieldValue("StampImageFilePath", "");
                          formik.setFieldValue("IsStampImageFileDeleted", true);
                        }}
                      >
                        <label htmlFor="removeFile" name=""></label>
                      </div>
                      <div className="avatar-preview">
                        <div id="imagePreview">
                          <img
                            id="saveImageFile"
                            src={stampImage ? stampImage : img200}
                            alt={"Stamp Image"}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    {!editHeaderInwardIdParam && (
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-1"
                        title="Select Work Detail"
                        style={{ float: "right" }}
                        onClick={() => {
                          setShowWorkDetailModal(true);
                        }}
                      >
                        <i className="fa fa-edit"></i>
                      </Link>
                    )}
                    {editHeaderInwardIdParam ? (
                      formik?.values?.IsHeaderDetailWorkDetailChange ==
                      false ? (
                        <Link
                          to="#"
                          className="me-1"
                          title="Edit"
                          style={{ float: "right" }}
                          onClick={handleChangeHeaderDetailWorkDetailChange}
                        >
                          {SVGICON.EditSquareDanger}{" "}
                          <label
                            className="mb-1 text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Edit
                          </label>
                        </Link>
                      ) : (
                        <Link
                          to="#"
                          className="me-1"
                          title="Cancel"
                          style={{ float: "right" }}
                          onClick={cancelHeaderDetailWorkDetailChange}
                        >
                          {SVGICON.EditSquareDanger}{" "}
                          <label
                            className="mb-1 text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Cancel
                          </label>
                        </Link>
                      )
                    ) : (
                      ""
                    )}
                    <Field
                      label="Work Detail"
                      name="ProjectDetails"
                      placeholder={"Enter Work Detail"}
                      component={CustomTextArea}
                      rows={5}
                      // required
                      maxLength={2000}
                      disabled={
                        editHeaderInwardIdParam &&
                        formik?.values?.IsHeaderDetailWorkDetailChange == false
                      }
                    />
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={6}>
                        {editHeaderInwardIdParam ? (
                          formik?.values?.IsHeaderDetailLetterRefNoChange ==
                          false ? (
                            <Link
                              to="#"
                              className="me-1"
                              title="Edit"
                              style={{ float: "right" }}
                              onClick={
                                handleChangeHeaderDetailLetterRefNoChange
                              }
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Edit
                              </label>
                            </Link>
                          ) : (
                            <Link
                              to="#"
                              className="me-1"
                              title="Cancel"
                              style={{ float: "right" }}
                              onClick={cancelHeaderDetailLetterRefNoChange}
                            >
                              {SVGICON.EditSquareDanger}{" "}
                              <label
                                className="mb-1 text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                Cancel
                              </label>
                            </Link>
                          )
                        ) : (
                          ""
                        )}
                        <Field
                          label="Letter Ref No"
                          name="LetterRefNo"
                          placeholder={"Enter Letter Ref No"}
                          component={CustomInput}
                          maxLength={100}
                          disabled={
                            editHeaderInwardIdParam &&
                            formik?.values?.IsHeaderDetailLetterRefNoChange ==
                              false
                          }
                        />
                      </Col>
                      <Col lg={6}>
                        {ListOfLetterRefDoc.length > 0 ? (
                          <label
                            // style={{ color: "#4189e8" }}
                            className="text-primary"
                            title="File Uploaded"
                          >
                            Letter Ref Doc
                          </label>
                        ) : (
                          <label>Letter Ref Doc </label>
                        )}
                        <div className="mb-2">
                          <div className="input-group">
                            <span className="form-control form-control-sm ps-2">
                              <Link
                                to="#"
                                className="text-primary"
                                onClick={() => {
                                  setShowLetterRefDocModal(true);
                                }}
                              >
                                View Letter Ref Doc
                              </Link>
                            </span>
                            <div
                              className="input-group-text"
                              title="Choose File"
                              style={{
                                borderRadius: "0 0.375rem 0.375rem 0",
                              }}
                            >
                              <div className="open-file">
                                <input
                                  // type="file"
                                  id="LetterRefUpload"
                                  ////accept="image/png, image/gif, image/jpeg"
                                  //onChange={uploadLetterRefDoc}
                                  onClick={() => {
                                    setShowLetterRefDocModal(true);
                                  }}
                                />
                                <label
                                  htmlFor="LetterRefUpload"
                                  name=""
                                ></label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <label className="mb-1"></label>
                        <div className="d-flex mb-2">
                          <text className="badge badge-warning light border-0 ms-0 p-0 ps-1 mb-1 me-1">
                            <label className="mb-1">TPI Required &nbsp;</label>
                          </text>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckIsTPIRequired"
                              title={IsTPIRequired == true ? "Yes" : "No"}
                              checked={IsTPIRequired}
                              onChange={handleChangeIsTPIRequired}
                              style={{ cursor: "pointer" }}
                            ></input>
                          </div>
                        </div>
                      </Col>
                      {IsTPIRequired == true && (
                        <Col lg={6}>
                          {/* {editHeaderInwardIdParam &&
                          formik?.values?.originalIsTPIRequired == true ? (
                            formik?.values?.IsHeaderDetailTPIDetailChange ==
                            false ? (
                              <Link
                                to="#"
                                className="me-1"
                                title="Edit"
                                style={{ float: "right" }}
                                onClick={
                                  handleChangeHeaderDetailTPIDetailChange
                                }
                              >
                                {SVGICON.EditSquareDanger}{" "}
                                <label
                                  className="mb-1 text-danger"
                                  style={{ cursor: "pointer" }}
                                >
                                  Edit
                                </label>
                              </Link>
                            ) : (
                              <Link
                                to="#"
                                className="me-1"
                                title="Cancel"
                                style={{ float: "right" }}
                                onClick={cancelHeaderDetailTPIDetailChange}
                              >
                                {SVGICON.EditSquareDanger}{" "}
                                <label
                                  className="mb-1 text-danger"
                                  style={{ cursor: "pointer" }}
                                >
                                  Cancel
                                </label>
                              </Link>
                            )
                          ) : (
                            ""
                          )} */}

                          {ListOfTPIDetails.length > 0 ? (
                            <label
                              // style={{ color: "#4189e8" }}
                              className="text-primary"
                              title="TPI is Available"
                            >
                              TPI Details
                            </label>
                          ) : (
                            <label>TPI Details</label>
                          )}
                          <div className="mb-2">
                            <div className="input-group">
                              <span className="form-control form-control-sm ps-2">
                                <Link
                                  to="#"
                                  className="text-primary"
                                  // style={{
                                  //   cursor:
                                  //     editHeaderInwardIdParam &&
                                  //     formik?.values
                                  //       ?.IsHeaderDetailTPIDetailChange == false
                                  //       ? "not-allowed"
                                  //       : "pointer",
                                  // }}
                                  onClick={() => {
                                    // if (
                                    //   editHeaderInwardIdParam &&
                                    //   formik?.values
                                    //     ?.IsHeaderDetailTPIDetailChange == false
                                    // ) {
                                    // } else {
                                    setShowTPIDetailModal(true);
                                    // }
                                  }}
                                >
                                  View TPI Details
                                </Link>
                              </span>
                              <div
                                className="input-group-text"
                                title="Add TPI Detail"
                                style={{
                                  borderRadius: "0 0.375rem 0.375rem 0",
                                  cursor: "pointer",
                                  // cursor:
                                  //   editHeaderInwardIdParam &&
                                  //   formik?.values
                                  //     ?.IsHeaderDetailTPIDetailChange == false
                                  //     ? "not-allowed"
                                  //     : "pointer",
                                }}
                                onClick={() => {
                                  // if (
                                  //   editHeaderInwardIdParam &&
                                  //   formik?.values
                                  //     ?.IsHeaderDetailTPIDetailChange == false
                                  // ) {
                                  // } else {
                                  addNewTPI();
                                  // }
                                }}
                              >
                                <i className="fa fa-plus" />
                              </div>
                            </div>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
                {AuthUser?.Permissions?.InwardClubing == true ? (
                  <Row>
                    {CustomerIDEncrypted ? (
                      <>
                        <Col lg={6}>
                          <div className="d-flex">
                            <div className="pt-2">
                              <label className="mb-1"></label>
                              <div className="d-flex mb-2">
                                <label className="mb-1">
                                  Inward Clubing &nbsp;
                                </label>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="flexSwitchCheckInwardClubing"
                                    title={InwardClubing == true ? "Yes" : "No"}
                                    checked={InwardClubing}
                                    onChange={handleChangeInwardClubing}
                                    style={{ cursor: "pointer" }}
                                  ></input>
                                </div>
                              </div>
                            </div>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{ flex: 1 }}>
                              {InwardClubing ? (
                                <Field
                                  label="Clubing Inward No"
                                  name="InwardIDsClubing"
                                  placeholder={"Select Inward No"}
                                  options={inwardNoClubingOptions}
                                  component={CustomMultiSelect}
                                  isMulti={true}
                                  menuPosition="fixed"
                                  onChange={handleChangeInwardNos}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                  </Row>
                ) : (
                  ""
                )}
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <Col lg={6}>
                    <label>Material Information</label>
                  </Col>
                  {CopyInwardIdParam && (
                    <Col lg={6} style={{ textAlign: "right" }}>
                      <span className="text-warning fs-12">
                        [Note: Sample Images are not copied & Test details are
                        copied automatically upon saving.]
                      </span>
                    </Col>
                  )}

                  {editHeaderInwardIdParam && (
                    <Col lg={6} style={{ textAlign: "right" }}>
                      <span className="text-danger fs-12">
                        [Note: Changed Sample information will result in the
                        deletion of related transactions, such as Report
                        Printing
                        {AuthUser?.Permissions?.UploadScanCopy == 1
                          ? " and Upload Scan Copy"
                          : ""}
                        , if they exist.]
                      </span>
                    </Col>
                  )}

                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="MaterialInfo-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="MaterialInfo-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%">
                                {!editHeaderInwardIdParam && (
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md bg-primary-light"
                                    title="Add New"
                                    onClick={() => {
                                      AddNewMaterialInformation();
                                    }}
                                  >
                                    <i className="fa fa-plus"></i>
                                  </Link>
                                )}
                              </th>
                              {/* <th width="14%">Department</th> */}
                              {(IsTCNoBasedOnInwardNo == false ||
                                (InwardCurrentStatus > 1 &&
                                  (PrimaryIdParam ||
                                    editHeaderInwardIdParam))) && (
                                <th width="14%">TC No</th>
                              )}
                              {/* <th width="14%">Material Group</th>
                              <th width="14%">Material Type</th> */}
                              {/* <th width="14%">Size</th>
                              <th width="14%">Condition</th>
                              <th width="23%">Sample Detail</th> */}
                              <th width="39%">Sample Detail</th>
                              <th width="20%">Condition</th>
                              <th width="20%">Size</th>
                              <th width="4%" style={{ textAlign: "left" }}>
                                Images
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfMaterials?.filter(
                              (x) => x.IsDeleted == false
                            )?.length > 0 ? (
                              ListOfMaterials?.map((item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display:
                                      item.IsDeleted == true ? "none" : "",
                                    backgroundColor:
                                      item?.IsErrorDisplay == true
                                        ? "#f69393"
                                        : "",
                                  }}
                                >
                                  <td className="p-1">
                                    {editHeaderInwardIdParam ? (
                                      item?.IsHeaderDetailMaterialInformationChange ==
                                      false ? (
                                        <Link
                                          to="#"
                                          className="me-1"
                                          title="Edit"
                                          onClick={() => {
                                            handleChangeHeaderDetailMaterialInformationChange(
                                              indx
                                            );
                                          }}
                                        >
                                          {SVGICON.EditSquareDanger}{" "}
                                          <label
                                            className="mb-1 text-danger"
                                            style={{ cursor: "pointer" }}
                                          >
                                            Edit
                                          </label>
                                        </Link>
                                      ) : (
                                        <Link
                                          to="#"
                                          className="me-1"
                                          title="Cancel"
                                          style={{ float: "right" }}
                                          onClick={() => {
                                            cancelHeaderDetailMaterialInformationChange(
                                              indx
                                            );
                                          }}
                                        >
                                          {SVGICON.EditSquareDanger}{" "}
                                          <label
                                            className="mb-1 text-danger"
                                            style={{ cursor: "pointer" }}
                                          >
                                            Cancel
                                          </label>
                                        </Link>
                                      )
                                    ) : (
                                      <>
                                        <Link
                                          to="#"
                                          className="icon-box icon-box-md me-1"
                                          title="Delete"
                                          onClick={() => {
                                            //deleteMaterialInformation(indx);
                                            delete_RecordWithoutApi(
                                              deleteMaterialInformation,
                                              indx
                                            );
                                          }}
                                        >
                                          {SVGICON.DeleteDanger}
                                        </Link>
                                        <Link
                                          to="#"
                                          className="icon-box icon-box-md"
                                          title="Repeat"
                                          onClick={() => {
                                            formik.setFieldValue(
                                              "selectedMaterialInfoRow",
                                              indx
                                            );
                                            formikMaterialInfoRepeatRow.resetForm();
                                            setShowMaterialInfoRepeatRowQtyModal(
                                              true
                                            );
                                          }}
                                        >
                                          <i className="fa fa-repeat" />
                                        </Link>
                                      </>
                                    )}
                                  </td>
                                  {/* <td
                                    className="p-1"
                                    style={{ minWidth: "150px" }}
                                  >
                                    <Field
                                      name={`ListOfMaterials[${indx}].DepartmentIDEncrypted`}
                                      placeholder={"Department"}
                                      options={departmentOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListOfMaterials[${indx}].DepartmentIDEncrypted`,
                                          e?.value ?? ""
                                        );
                                        getProductGroupDDL(
                                          e?.value ?? "",
                                          indx
                                        );
                                        formik.setFieldValue(
                                          `ListOfMaterials[${indx}].ProductGroupIDEncrypted`,
                                          ""
                                        );
                                        getMaterialTypeDDL(
                                          e?.value ?? "",
                                          "",
                                          indx
                                        );
                                      }}
                                      // style={{ borderColor: "red" }}
                                    />
                                  </td> */}

                                  {/* <td
                                      className="p-1"
                                      style={{ minWidth: "150px" }}
                                    >
                                      {item.TCNoAllocated == false ||
                                      !item.InwardMaterialIDEncrypted ? (
                                        <Field
                                          name={`ListOfMaterials[${indx}].TCNo`}
                                          placeholder={"TC No"}
                                          options={tcNoOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                        />
                                      ) : (
                                        <Field
                                          name={`ListOfMaterials[${indx}].TCNo`}
                                          placeholder={"TC No"}
                                          component={CustomInput}
                                          disabled={true}
                                          noMarginBottom={true}
                                        />
                                      )}
                                    </td> */}
                                  {IsTCNoBasedOnInwardNo == false ||
                                  (InwardCurrentStatus > 1 &&
                                    (PrimaryIdParam ||
                                      editHeaderInwardIdParam)) ? (
                                    <td
                                      className="p-1"
                                      style={{ minWidth: "150px" }}
                                    >
                                      {(item.TCNoAllocated == false ||
                                        !item.InwardMaterialIDEncrypted) &&
                                      IsTCNoBasedOnInwardNo == false ? (
                                        <Field
                                          name={`ListOfMaterials[${indx}].TCNo`}
                                          placeholder={"TC No"}
                                          options={tcNoOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                        />
                                      ) : item.TCNoAllocated == false ||
                                        !item.InwardMaterialIDEncrypted ? (
                                        ""
                                      ) : (
                                        <Field
                                          name={`ListOfMaterials[${indx}].TCNo`}
                                          placeholder={"TC No"}
                                          component={CustomInput}
                                          disabled={true}
                                          noMarginBottom={true}
                                        />
                                      )}
                                    </td>
                                  ) : (
                                    ""
                                  )}

                                  {/* <td
                                    className="p-1"
                                    style={{ minWidth: "150px" }}
                                  >
                                    <Field
                                      name={`ListOfMaterials[${indx}].ProductGroupIDEncrypted`}
                                      placeholder={"Material Group"}
                                      // options={item.productGroupOptions}
                                      options={productGroupOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListOfMaterials[${indx}].ProductGroupIDEncrypted`,
                                          e?.value ?? ""
                                        );
                                        // getMaterialTypeDDL(
                                        //   item.DepartmentIDEncrypted,
                                        //   e?.value ?? "",
                                        //   indx
                                        // );
                                        getMaterialTypeDDL(
                                          e?.value ?? "",
                                          indx
                                        );
                                        formik.setFieldValue(
                                          `ListOfMaterials[${indx}].MaterialTypeIDEncrypted`,
                                          ""
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{ minWidth: "150px" }}
                                  >
                                    <Field
                                      name={`ListOfMaterials[${indx}].MaterialTypeIDEncrypted`}
                                      placeholder={"Material Type"}
                                      options={item.materialTypeOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                    />
                                  </td> */}

                                  <td
                                    className="p-1"
                                    style={{ minWidth: "230px" }}
                                  >
                                    <Field
                                      name={`ListOfMaterials[${indx}].SampleDetail`}
                                      placeholder={"Sample Detail"}
                                      component={CustomInput}
                                      maxLength={2000}
                                      noMarginBottom={true}
                                      disabled={
                                        editHeaderInwardIdParam &&
                                        item?.IsHeaderDetailMaterialInformationChange ==
                                          false
                                      }
                                    />
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{ minWidth: "150px" }}
                                  >
                                    <Field
                                      name={`ListOfMaterials[${indx}].Condition`}
                                      placeholder={"Condition"}
                                      component={CustomInput}
                                      maxLength={500}
                                      noMarginBottom={true}
                                      disabled={
                                        editHeaderInwardIdParam &&
                                        item?.IsHeaderDetailMaterialInformationChange ==
                                          false
                                      }
                                    />
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{ minWidth: "150px" }}
                                  >
                                    <Field
                                      name={`ListOfMaterials[${indx}].Size`}
                                      placeholder={"Size"}
                                      component={CustomInput}
                                      maxLength={500}
                                      noMarginBottom={true}
                                      disabled={
                                        editHeaderInwardIdParam &&
                                        item?.IsHeaderDetailMaterialInformationChange ==
                                          false
                                      }
                                    />
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{ textAlign: "center" }}
                                  >
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light"
                                      className="icon-box icon-box-md"
                                      onClick={() => {
                                        if (
                                          editHeaderInwardIdParam &&
                                          item?.IsHeaderDetailMaterialInformationChange ==
                                            false
                                        ) {
                                        } else {
                                          setShowMaterialInfoImagesModal(true);
                                          formik.setFieldValue(
                                            "selectedMaterialInfoRow",
                                            indx
                                          );
                                          setMaterialPhotoFile(null);
                                          setMaterialPhoto(null);
                                        }
                                      }}
                                      disabled={
                                        editHeaderInwardIdParam &&
                                        item?.IsHeaderDetailMaterialInformationChange ==
                                          false
                                      }
                                    >
                                      {/* Upload / View */}
                                      <i className="fa fa-cloud-upload"></i>
                                    </Link>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={8} style={{ textAlign: "left" }}>
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <ErrorMessage
                        name={"ListOfMaterials"}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                    </div>
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <label>Mode</label>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="Mode-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="Mode-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="14%">Mode Type</th>
                              <th width="14%">Mode By </th>
                              <th width="18%">Customer</th>
                              <th width="18%">Project</th>
                              <th width="20%">Address</th>
                              <th width="16%" style={{ textAlign: "left" }}>
                                Contact Person
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfModeDetails?.map((item, idx) => (
                              <tr
                                key={idx}
                                style={{
                                  display:
                                    item.ModeDetailID == 4 &&
                                    IsMaterialReturnable == false
                                      ? "none"
                                      : "",
                                }}
                              >
                                <td
                                  className="p-1 ps-3"
                                  style={{ minWidth: "150px" }}
                                >
                                  <label>
                                    {item.ModeDetailID == 1
                                      ? "Sample Submitted By"
                                      : item.ModeDetailID == 2
                                      ? "Reporting"
                                      : item.ModeDetailID == 3
                                      ? "Billing"
                                      : item.ModeDetailID == 4
                                      ? "Dispatch"
                                      : ""}
                                  </label>
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "150px" }}
                                >
                                  {item.ModeDetailID > 1 ? (
                                    item.ModeDetailID == 4 ? (
                                      <Field
                                        name={`ListOfModeDetails[${idx}].ModeType`}
                                        placeholder={"Mode By"}
                                        options={dispatchMaterialModeOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                      />
                                    ) : (
                                      <Field
                                        name={`ListOfModeDetails[${idx}].ModeType`}
                                        placeholder={"Mode By"}
                                        options={modeByOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                      />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "160px" }}
                                >
                                  {/* <Field
                                    name={`ListOfModeDetails[${idx}].CustomerIDEncrypted`}
                                    placeholder={"Customer"}
                                    options={customerOptions}
                                    component={CustomSelect}
                                    noMarginBottom={true}
                                    menuPosition="fixed"
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerIDEncrypted`,
                                        e?.value ?? ""
                                      );
                                      getProjectDDLModeDetails(
                                        e?.value ?? "",
                                        idx
                                      );
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerProjectIDEncrypted`,
                                        ""
                                      );
                                      getProjectAddressDDL(
                                        e?.value ?? "",
                                        "",
                                        idx
                                      );
                                      getContactPersonDDL(
                                        e?.value ?? "",
                                        "",
                                        idx
                                      );
                                    }}
                                  /> */}
                                  <Field
                                    name={`ListOfModeDetails[${idx}].CustomerIDEncrypted`}
                                    placeholder={"Customer"}
                                    //options={customerOptions}
                                    loadOptionsFn={loadOptionsCutomer}
                                    component={CustomSelectAsync}
                                    title={item?.CustomerName}
                                    labelFieldName={`ListOfModeDetails[${idx}].CustomerName`}
                                    noMarginBottom={true}
                                    menuPosition="fixed"
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerIDEncrypted`,
                                        e?.value ?? ""
                                      );
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerName`,
                                        e?.label ?? ""
                                      );
                                      getProjectDDLModeDetails(
                                        e?.value ?? "",
                                        idx
                                      );
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerProjectIDEncrypted`,
                                        ""
                                      );
                                      getProjectAddressDDL(
                                        e?.value ?? "",
                                        "",
                                        idx
                                      );
                                      getContactPersonDDL(
                                        e?.value ?? "",
                                        "",
                                        idx
                                      );
                                    }}
                                  />
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "160px" }}
                                >
                                  <Field
                                    name={`ListOfModeDetails[${idx}].CustomerProjectIDEncrypted`}
                                    placeholder={"Project"}
                                    options={item.projectOptions}
                                    component={CustomSelect}
                                    noMarginBottom={true}
                                    menuPosition="fixed"
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerProjectIDEncrypted`,
                                        e?.value ?? ""
                                      );
                                      getProjectAddressDDL(
                                        item.CustomerIDEncrypted,
                                        e?.value ?? "",
                                        idx
                                      );
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerProjectAddressIDEncrypted`,
                                        ""
                                      );
                                      getContactPersonDDL(
                                        item.CustomerIDEncrypted,
                                        e?.value ?? "",
                                        idx
                                      );
                                      formik.setFieldValue(
                                        `ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`,
                                        ""
                                      );
                                    }}
                                  />
                                </td>
                                <td
                                  className="p-1"
                                  style={{ minWidth: "180px" }}
                                >
                                  <Field
                                    name={`ListOfModeDetails[${idx}].CustomerProjectAddressIDEncrypted`}
                                    placeholder={"Address"}
                                    options={item.projectAddressOptions}
                                    component={CustomSelect}
                                    noMarginBottom={true}
                                    menuPosition="fixed"
                                  />
                                </td>
                                <td
                                  className="p-1"
                                  style={{
                                    textAlign: "left",
                                    minWidth: "150px",
                                  }}
                                >
                                  {item.ModeDetailID == 2 ? (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                      placeholder={"Contact Person"}
                                      // options={item.contactPersonOptions}
                                      options={item.contactPersonOptions.filter(
                                        (x) => x.IsReporting == true
                                      )}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      menuStyles={{
                                        position: "absolute",
                                        right: 0,
                                      }}
                                    />
                                  ) : item.ModeDetailID == 3 ? (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                      placeholder={"Contact Person"}
                                      // options={item.contactPersonOptions}
                                      options={item.contactPersonOptions.filter(
                                        (x) => x.IsBilling == true
                                      )}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      menuStyles={{
                                        position: "absolute",
                                        right: 0,
                                      }}
                                    />
                                  ) : item.ModeDetailID == 4 ? (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                      placeholder={"Contact Person"}
                                      // options={item.contactPersonOptions}
                                      options={item.contactPersonOptions.filter(
                                        (x) => x.IsDispatch == true
                                      )}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      menuStyles={{
                                        position: "absolute",
                                        right: 0,
                                      }}
                                    />
                                  ) : (
                                    <Field
                                      name={`ListOfModeDetails[${idx}].CustomerContactPersonIDEncrypted`}
                                      placeholder={"Contact Person"}
                                      options={item.contactPersonOptions}
                                      component={CustomSelect}
                                      noMarginBottom={true}
                                      menuPosition="fixed"
                                      menuStyles={{
                                        position: "absolute",
                                        right: 0,
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Expected Delivery Date"
                      name="ExpectedDateOfDelivery"
                      placeholder={"Select Expected Delivery Date"}
                      component={CustomFlatpickr}
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                        minDate: InwardDate ? InwardDate : new Date(),
                      }}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Material Taken By Employee"
                      name="MaterialTakenByUserEncrypted"
                      placeholder={"Select Material Taken By"}
                      options={employeeOptions}
                      component={CustomSelect}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Sample Received Via"
                      name="MaterialReceiveViaID"
                      placeholder={"Select Sample Received Via"}
                      options={sampleReceivedViaOptions}
                      component={CustomSelect}
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Reference By"
                      name="ReferenceByIDEncrypted"
                      placeholder={"Select Reference By"}
                      options={referredByOptions}
                      component={CustomSelect}
                      menuStyles={{
                        position: "absolute",
                        right: 0,
                      }}
                    />
                  </Col>
                  <Col lg={6}>
                    <Field
                      label="Delivery Remarks"
                      name="EDDRemarks"
                      placeholder={"Enter Delivery Remarks"}
                      component={CustomTextArea}
                      rows={2}
                      maxLength={200}
                    />
                  </Col>
                  <Col lg={6}>
                    <Field
                      label="Received Remarks"
                      name="ReceiveRemarks"
                      placeholder={"Enter Received Remarks"}
                      component={CustomTextArea}
                      rows={2}
                      maxLength={100}
                    />
                  </Col>
                </Row>
                {ListOfReviews?.length > 0 && (
                  <>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <label>Customer Review</label>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting mb-2">
                          <div
                            id="Review-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer"
                          >
                            <table
                              id="Review-tbl"
                              className="table table-bordered no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="4%"></th>
                                  <th width="82%">Points Reviewed</th>
                                  <th width="14%" style={{ textAlign: "left" }}>
                                    Status of review
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfReviews?.length > 0 ? (
                                  ListOfReviews?.map((item, indx) => (
                                    <tr key={indx}>
                                      <td
                                        className="p-1 text-center"
                                        style={{ minWidth: "40px" }}
                                      >
                                        {indx + 1}
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{ minWidth: "180px" }}
                                      >
                                        {item.Review}
                                      </td>

                                      <td
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfReviews[${indx}].StatusOfReview`}
                                          placeholder={"Select"}
                                          options={yesNoOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                          isClearable={false}
                                        />
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={3}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
                {editHeaderInwardIdParam && (
                  <Row>
                    <Col lg={6}>
                      <Field
                        label="Change Reason"
                        name="ChangeReason"
                        placeholder={"Enter Change Reason"}
                        component={CustomTextArea}
                        rows={5}
                        maxLength={500}
                        required
                      />
                    </Col>
                  </Row>
                )}
                <div className="stickyBottomButtons">
                  <hr className="mt-1 mb-2"></hr>
                  {InwardCurrentStatus == 1 && (
                    <>
                      <button
                        type="submit"
                        // className="btn btn-primary"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => {
                          formik.setFieldValue("btnSubmitType", 1);
                        }}
                      >
                        <i className="fa-solid fa-bookmark"></i> Draft
                      </button>
                    </>
                  )}
                  <button
                    type="submit"
                    // className="btn btn-primary"
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      formik.setFieldValue("btnSubmitType", 2);
                    }}
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showLetterRefDocModal}
          onHide={setShowLetterRefDocModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Letter Ref Doc</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowLetterRefDocModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="mb-2">
                    <label></label>
                    <div className="avatar-file">
                      <input
                        type="file"
                        id="LetterRefUpload2"
                        //accept="image/png, image/gif, image/jpeg"
                        onChange={uploadLetterRefDoc}
                        //key={fileKeyLetterRefDocPhoto || ""}
                      />
                      <label htmlFor="LetterRefUpload2" name=""></label>
                    </div>
                    <div
                      id="webCam"
                      className="avatar-camera"
                      onClick={() => {
                        setOpenWebCamModalLetterRefDocImage(true);
                      }}
                      style={{ marginLeft: "50px" }}
                    >
                      <input type="hidden" />
                      <label htmlFor="webCam" name=""></label>
                    </div>
                  </div>
                  {/* <div style={{ float: "right", marginRight: "2rem" }}>
                    + Add
                    <div
                      className="open-file mt-2"
                      style={{ marginLeft: "2rem" }}
                    >
                      <input
                        type="file"
                        id="LetterRefUpload2"
                        //accept="image/png, image/gif, image/jpeg"
                        onChange={uploadLetterRefDoc}
                      />
                      <label htmlFor="LetterRefUpload2" name=""></label>
                    </div>
                  </div> */}
                </Col>
                {letterRefDocPhoto && (
                  <Col lg={12}>
                    <div className="d-flex">
                      <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                        <div className="avatar-preview">
                          <div id="imagePreview">
                            <img
                              id="saveImageFile"
                              src={
                                letterRefDocPhoto ? letterRefDocPhoto : img200
                              }
                              alt={"Material Image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            addLetterRefDocFile();
                          }}
                        >
                          <i className="fa fa-cloud-upload"></i> Upload
                        </button>
                        <button
                          // className="btn btn-sm btn-danger light"
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setLetterRefDocPhoto(null);
                            setLetterRefDocPhotoFile(null);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="LetterRefDoc-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="LetterRefDoc-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              File Name
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfLetterRefDoc?.filter(
                            (x) => x.IsDeleted == false
                          )?.length > 0 ? (
                            ListOfLetterRefDoc?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.LetterRefImageFilePath
                                          ? item.LetterRefImageFilePath
                                          : item.viewFile
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      //deleteLetterRefDoc(indx);
                                      delete_RecordWithoutApi(
                                        deleteLetterRefDoc,
                                        indx
                                      );
                                    }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {item.LetterRefImageFileName}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {openWebCamModalLetterRefDocImage == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowLetterRefDocModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={openWebCamModalLetterRefDocImage}
          onHide={setOpenWebCamModalLetterRefDocImage}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenWebCamModalLetterRefDocImage(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  onUserMedia={onUserMedia}
                  className="webCam"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // className="btn btn-primary "
              variant="primary btn-sm"
              onClick={captureLetterRefDocPhoto}
            >
              <i className="fa fa-camera"></i> Capture
            </Button>

            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenWebCamModalLetterRefDocImage(false);
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          className="fade"
          show={showAddTPIDetailModal}
          onHide={setShowAddTPIDetailModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTPIDetail}>
              <Form onSubmit={formikTPIDetail.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    {actionFlagTPI == 1 ? "Edit" : "Add"} TPI Detail
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowAddTPIDetailModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="TPI"
                        name="TPIIDEncrypted"
                        placeholder={"Select TPI"}
                        options={tpiCustomerOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikTPIDetail.setFieldValue(
                            "TPIIDEncrypted",
                            e?.value ?? ""
                          );
                          formikTPIDetail.setFieldValue(
                            "TPIName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="TPI Contact Person"
                        name="TPIContactPersonIDEncrypted"
                        placeholder={"Select Contact Person"}
                        options={tpiContactPersonOptions}
                        component={CustomSelect}
                        required
                        onChange={(e) => {
                          formikTPIDetail.setFieldValue(
                            "TPIContactPersonIDEncrypted",
                            e?.value ?? ""
                          );
                          formikTPIDetail.setFieldValue(
                            "TPIContactPersonName",
                            e?.label ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="TPI Expected Date"
                        name="TPIExpectedDate"
                        placeholder={"Select Expected Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          minDate: InwardDate ? InwardDate : new Date(),
                          static: true, //to solve month dropdown not visible inside modal
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setShowAddTPIDetailModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showTPIDetailModal}
          onHide={setShowTPIDetailModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>TPI Detail</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowTPIDetailModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                {/* <Col lg={12}>
                  <div className="mb-1" style={{ float: "right" }}>
                    <button
                      // className="btn btn-sm btn-primary"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        addNewTPI();
                      }}
                    >
                      <i className="fa-solid fa-plus"></i> Add
                    </button>
                  </div>
                </Col> */}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="TPIdetail-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="TPIdetail-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%">
                              <Link
                                to="#"
                                className="icon-box icon-box-md bg-primary-light me-1"
                                title="Add TPI Detail"
                                onClick={() => {
                                  addNewTPI();
                                }}
                              >
                                <i className="fa fa-plus"></i>
                              </Link>
                            </th>
                            <th width="46%">TPI</th>
                            <th width="30%">TPI Contact Person</th>
                            <th width="20%" style={{ textAlign: "left" }}>
                              TPI Expected Date
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfTPIDetails?.filter((x) => x.IsDeleted == false)
                            ?.length > 0 ? (
                            ListOfTPIDetails?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                    onClick={() => {
                                      editTPI(indx);
                                    }}
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      //deleteTPI(indx);
                                      delete_RecordWithoutApi(deleteTPI, indx);
                                    }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                </td>
                                <td>{item.TPIName}</td>
                                <td>{item.TPIContactPersonName}</td>
                                <td style={{ textAlign: "left" }}>
                                  {item.displayTPIExpectedDate}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {showAddTPIDetailModal == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowTPIDetailModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showMaterialInfoImagesModal}
          onHide={setShowMaterialInfoImagesModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Images - Material Information</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowMaterialInfoImagesModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="mb-2">
                    <label></label>
                    <div className="avatar-file">
                      <input
                        type="file"
                        id="imageUploadMaterial"
                        accept="image/png, image/gif, image/jpeg"
                        onChange={uploadMaterialPhoto}
                        key={fileKeyMaterialPhoto || ""}
                      />
                      <label htmlFor="imageUploadMaterial" name=""></label>
                    </div>
                    <div
                      id="webCam"
                      className="avatar-camera"
                      onClick={() => {
                        setOpenWebCamModalMaterialImage(true);
                      }}
                      style={{ marginLeft: "50px" }}
                    >
                      <input type="hidden" />
                      <label htmlFor="webCam" name=""></label>
                    </div>
                  </div>
                </Col>
                {materialPhoto && (
                  <Col lg={12}>
                    <div className="d-flex">
                      <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                        <div className="avatar-preview">
                          <div id="imagePreview">
                            <img
                              id="saveImageFile"
                              src={materialPhoto ? materialPhoto : img200}
                              alt={"Material Image"}
                              style={{
                                maxHeight: "100px",
                                maxWidth: "100px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            addMaterialImage();
                          }}
                        >
                          <i className="fa fa-cloud-upload"></i> Upload
                        </button>
                        <button
                          // className="btn btn-sm btn-danger light"
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setMaterialPhoto(null);
                            setMaterialPhotoFile(null);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting">
                    <div
                      id="MaterialPhotos-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="MaterialPhotos-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="4%"></th>
                            <th width="96%" style={{ textAlign: "left" }}>
                              Image
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfMaterials[
                            selectedMaterialInfoRow
                          ]?.ListOfMaterialPhotos?.filter(
                            (x) => x.IsDeleted == false
                          )?.length > 0 ? (
                            ListOfMaterials[
                              selectedMaterialInfoRow
                            ]?.ListOfMaterialPhotos?.map((item, indx) => (
                              <tr
                                key={indx}
                                style={{
                                  display: item.IsDeleted == true ? "none" : "",
                                }}
                              >
                                <td>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.MaterialPhotoFilePath
                                          ? item.MaterialPhotoFilePath
                                          : item.viewFile
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      //deleteMaterialImage(indx);
                                      delete_RecordWithoutApi(
                                        deleteMaterialImage,
                                        indx
                                      );
                                    }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  <img
                                    src={
                                      item.MaterialPhotoFilePath
                                        ? item.MaterialPhotoFilePath
                                        : item.viewFile
                                    }
                                    alt={"Material Image"}
                                    style={{
                                      maxHeight: "50px",
                                      maxWidth: "50px",
                                    }}
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {(openCropperModalMaterialPhoto == true ||
                openWebCamModalMaterialImage == true) && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="secondary light"
                onClick={() => setShowMaterialInfoImagesModal(false)}
              >
                Close
              </Button>
            </Modal.Footer> */}
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={openCropperModalMaterialPhoto}
          onHide={setOpenCropperModalMaterialPhoto}
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>Material Image</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenCropperModalMaterialPhoto(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <Cropper
                  style={{ height: 400, width: 400 }}
                  // zoomTo={0.5}
                  zoomTo={zoomMaterialPhoto}
                  initialAspectRatio={1 / 1}
                  // aspectRatio={1 / 1}
                  src={imageMaterialPhoto}
                  // viewMode={1}
                  // minCropBoxHeight={500}
                  // minCropBoxWidth={500}
                  // maxCropBoxHeight={500}
                  // maxCropBoxWidth={500}
                  background={false}
                  responsive={true}
                  // autoCropArea={1}
                  checkOrientation={false}
                  onInitialized={(instance) => {
                    setCropperMaterialPhoto(instance);
                  }}
                  //guides={false}
                  checkCrossOrigin={false}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // variant="secondary light"
              variant="secondary light btn-sm"
              onClick={() => {
                setZoomMaterialPhoto(zoomMaterialPhoto + 0.5);
              }}
              title="zoom-in"
            >
              <i className="fa fa-search-plus"></i>
            </Button>
            <Button
              // variant="secondary light"
              variant="secondary light btn-sm"
              onClick={() => {
                setZoomMaterialPhoto(
                  zoomMaterialPhoto > 0.5
                    ? zoomMaterialPhoto - 0.5
                    : zoomMaterialPhoto
                );
              }}
              title="zoom-out"
            >
              <i className="fa fa-search-minus"></i>
            </Button>
            <Button
              // className="btn btn-primary"
              variant="primary btn-sm"
              onClick={() => {
                getCropDataMaterialPhoto();
                setOpenCropperModalMaterialPhoto(false);
                setFileKeyMaterialPhoto(
                  Math.random().toString(9).substring(2, 9)
                );
              }}
            >
              <i className="fa fa-crop"></i> Crop Image
            </Button>
            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenCropperModalMaterialPhoto(false);
                setFileKeyMaterialPhoto(
                  Math.random().toString(9).substring(2, 9)
                );
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          className="fade"
          show={openWebCamModalMaterialImage}
          onHide={setOpenWebCamModalMaterialImage}
        >
          <Modal.Header>
            <Modal.Title>Material Image</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setOpenWebCamModalMaterialImage(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  onUserMedia={onUserMedia}
                  className="webCam"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              // className="btn btn-primary "
              variant="primary btn-sm"
              onClick={capturePhoto}
            >
              <i className="fa fa-camera"></i> Capture
            </Button>

            <Button
              // className="btn btn-danger light"
              variant="danger btn-sm"
              onClick={() => {
                setOpenWebCamModalMaterialImage(false);
              }}
            >
              <i className="fa fa-cancel"></i> Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          className="fade"
          show={showMaterialInfoRepeatRowQtyModal}
          onHide={setShowMaterialInfoRepeatRowQtyModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMaterialInfoRepeatRow}>
              <Form onSubmit={formikMaterialInfoRepeatRow.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Repeat Row - Material Information</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMaterialInfoRepeatRowQtyModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        type="number"
                        label="No of Repeat Row"
                        name="NoOfRepeatMaterialInfoRow"
                        placeholder={"Enter No of Repeat Row"}
                        component={CustomInput}
                        numberTypeWithoutDot={true}
                        required
                        onChange={(e) => {
                          let nRow = e?.target?.value ?? 0;
                          if (nRow >= 0 && nRow < 1000) {
                            formikMaterialInfoRepeatRow.setFieldValue(
                              "NoOfRepeatMaterialInfoRow",
                              e?.target?.value ?? ""
                            );
                          }
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // className="btn btn-primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>

                  <Button
                    // className="btn btn-danger light"
                    variant="danger btn-sm"
                    onClick={() => {
                      setShowMaterialInfoRepeatRowQtyModal(false);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showWorkDetailModal}
          onHide={setShowWorkDetailModal}
          size="lg"
        >
          <FormikProvider value={formikWorkDetail}>
            <Form onSubmit={formikWorkDetail.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Work Detail</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowWorkDetailModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive active-projects style-1 shorting mb-0">
                      <div
                        id="workDetail-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="workDetail-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Work Detail
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {projectWorkDetailList?.length > 0 ? (
                              projectWorkDetailList?.map((item, indx) => (
                                <tr key={indx}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "5%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkWorkDetail${indx}`}
                                      name={`chkWorkDetail${indx}`}
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        formikWorkDetail.setFieldValue(
                                          "projectWorkDetailList",
                                          projectWorkDetailList?.map(
                                            (x, idx) => {
                                              if (idx == indx) {
                                                return {
                                                  ...x,
                                                  IsSelected: true,
                                                };
                                              } else {
                                                return {
                                                  ...x,
                                                  IsSelected: false,
                                                };
                                              }
                                            }
                                          )
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "95%",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.WorkDetail}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "left" }}>
                                  <div>{"No record found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  // className="btn btn-primary"
                  variant="primary btn-sm"
                >
                  <i className="fa-solid fa-plus"></i> Add
                </Button>

                <Button
                  // className="btn btn-danger light"
                  variant="danger btn-sm"
                  onClick={() => {
                    setShowWorkDetailModal(false);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Modal>
      </div>
    </div>
  );
};

export default AddMaterialInward;
